import React, { useState, useEffect, useRef, ReactNode, useCallback } from 'react';
import { ArrowLeft, Download, Filter, Loader2, X, Calendar, ChevronDown, Search, Check, ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import {  ArrowRight } from 'lucide-react';
import DateRangeSelector from './DateRangeSelector';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import TotalsComponent from './TotalsComponents';
import CostsGraphComponent from './CostsGraphComponent';
import DaysComponents from './DaysComponents'

type OrderData = {
  date_activation: string;
  country: string;
  campaign: string;
  platform?: string;
  campaign_id?: string;
  campaign_original?: string;
  arppu: number;
  ltv: number;
  predicted_ltv: number;
  cpa_cost_per_action: number;
  cpu_cost_per_user: number;
  roi: number;
  predicted_roi: number;
  revenue_activation_count: number;
  revenue_activation_purchase_count: number | null;
  revenue_activation_purchase: number | null;  
  revenue_activation: number | null;
  revenue_p1: number | null;
  revenue_p1_count: number | null;
  revenue_p2: number | null;
  revenue_p2_count: number | null;
  revenue_p3: number | null;
  revenue_p3_count: number | null;
  revenue_p4: number | null;
  revenue_p4_count: number | null;
  revenue_p5: number | null;
  revenue_p5_count: number | null;
  revenue_p6: number | null;
  revenue_p6_count: number | null;
  revenue_p7: number | null;
  revenue_p7_count: number | null;
  revenue_p8: number | null;
  revenue_p8_count: number | null;
  revenue_p9: number | null;
  revenue_p9_count: number | null;
  revenue_p10: number | null;
  revenue_p10_count: number | null;
  revenue_p11: number | null;
  revenue_p11_count: number | null;
  revenue_p12: number | null;
  revenue_p12_count: number | null;
  predicted_revenue_p1?: number | null;
  predicted_revenue_p2?: number | null;
  predicted_revenue_p3?: number | null;
  predicted_revenue_p4?: number | null;
  predicted_revenue_p5?: number | null;
  predicted_revenue_p6?: number | null;
  predicted_revenue_p7?: number | null;
  predicted_revenue_p8?: number | null;
  predicted_revenue_p9?: number | null;
  predicted_revenue_p10?: number | null;
  predicted_revenue_p11?: number | null;
  predicted_revenue_p12?: number | null;
  early_predicted_revenue_p1?: number | null;
  early_predicted_revenue_p2?: number | null;
  early_predicted_revenue_p3?: number | null;
  early_predicted_revenue_p4?: number | null;
  early_predicted_revenue_p5?: number | null;
  early_predicted_revenue_p6?: number | null;
  early_predicted_revenue_p7?: number | null;
  early_predicted_revenue_p8?: number | null;
  early_predicted_revenue_p9?: number | null;
  early_predicted_revenue_p10?: number | null;
  early_predicted_revenue_p11?: number | null;
  early_predicted_revenue_p12?: number | null;
  predicted_churn_p1?: number | null;
  predicted_churn_p2?: number | null;
  predicted_churn_p3?: number | null;
  predicted_churn_p4?: number | null;
  predicted_churn_p5?: number | null;
  predicted_churn_p6?: number | null;
  predicted_churn_p7?: number | null;
  predicted_churn_p8?: number | null;
  predicted_churn_p9?: number | null;
  predicted_churn_p10?: number | null;
  predicted_churn_p11?: number | null;
  predicted_churn_p12?: number | null;
  count_unique_payers?: number | null;
  count_unique_payers_activation?: number | null;
  costs: number | null;
  total_revenue: number | null;
  total_predicted_revenue?: number | null;
};

type GroupedOrderData = {
  [date: string]: {
    [country: string]: OrderData[];
  };
};

// SVG галочка и крестик
const CheckIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2ecc71" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

const CrossIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e74c3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const AndroidDashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const { dbName } = useParams<{ dbName: string }>();
  const database = dbName || 'default';
  const [ordersData, setOrdersData] = useState<GroupedOrderData>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  
  // Состояние для расшифровки
  const [isExplanationEnabled, setIsExplanationEnabled] = useState<boolean>(false);
  const [hoverInfo, setHoverInfo] = useState<{ x: number, y: number, content: string } | null>(null);
  
const [viewType, setViewType] = useState<'table' | 'totals'>('totals');
const [historicalCoefficients, setHistoricalCoefficients] = useState<{ [country: string]: number }>({});
  // New state for sorting
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc' | null>(null);
  
  // Списки для фильтров
  const [countries, setCountries] = useState<string[]>([]);
  const [campaigns, setCampaigns] = useState<string[]>([]);
  const [availableDates, setAvailableDates] = useState<string[]>([]);

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  
  // Состояния для фильтров
  const [isFilterOpen, setIsFilterOpen] = useState<boolean>(true);
  const [showCountries, setShowCountries] = useState<boolean>(true);
  const [showCampaigns, setShowCampaigns] = useState<boolean>(true);

  const [showPChurn, setShowPChurn] = useState<boolean>(false);


const [hideAllPeriods, setHideAllPeriods] = useState<boolean>(true); // скрыты по умолчанию
const [showPeriodColumns, setShowPeriodColumns] = useState<number[]>([]); // пустой массив по умолчанию
const [showEarlyPredicted, setShowEarlyPredicted] = useState<boolean>(false); // выключен по умолчанию

const [showPlatform, setShowPlatform] = useState<boolean>(false); // скрыт по умолчанию

  const [hideP1ToP4, setHideP1ToP4] = useState<boolean>(false);
  const [showPredictedRevenue, setShowPredictedRevenue] = useState<boolean>(false);
  const [showPCount, setShowPCount] = useState<boolean>(false);
  
  // NEW: Add state for tax toggle and VAT rates
  const [showWithTax, setShowWithTax] = useState<boolean>(false);
  const [vatRates, setVatRates] = useState<{ [country: string]: number }>({});
  


  const [distributeUnknowns, setDistributeUnknowns] = useState<boolean>(false);
const [distributeDirect, setDistributeDirect] = useState<boolean>(false);

  const getTodayDate = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState<string[]>([]);
  const [dateFrom, setDateFrom] = useState<string>(getTodayDate());
  const [dateTo, setDateTo] = useState<string>(getTodayDate());
  const [singleDate, setSingleDate] = useState<string>(getTodayDate());
  const [useDateRange, setUseDateRange] = useState<boolean>(false);
  
  // Модальные окна вместо выпадающих списков
  const [isCountryModalOpen, setIsCountryModalOpen] = useState<boolean>(false);
  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState<boolean>(false);


  
  // Поиск в выпадающих списках

  
  // Refs для выпадающих списков
  const filtersRef = useRef<HTMLDivElement>(null);
  const countryModalRef = useRef<HTMLDivElement>(null);
  const campaignModalRef = useRef<HTMLDivElement>(null);

  // NEW: Состояние для фильтра платформ
  const [platforms, setPlatforms] = useState<string[]>([]);
  const [selectedPlatforms, setSelectedPlatforms] = useState<string[]>([]);
  const [isPlatformModalOpen, setIsPlatformModalOpen] = useState<boolean>(false);

  const platformModalRef = useRef<HTMLDivElement>(null);

  // NEW: State variable for view mode (daily or monthly)
  const [viewMode, setViewMode] = useState<'daily' | 'monthly' | 'weekly'>('daily');

  // NEW: Month/Year filters for monthly view
  const [yearFrom, setYearFrom] = useState<string>(new Date().getFullYear().toString());
  const [yearTo, setYearTo] = useState<string>(new Date().getFullYear().toString());
  const [monthFrom, setMonthFrom] = useState<string>('1');
  const [monthTo, setMonthTo] = useState<string>('12');
  const [singleYear, setSingleYear] = useState<string>(new Date().getFullYear().toString());
  const [singleMonth, setSingleMonth] = useState<string>(new Date().getMonth() + 1 + '');

  // Состояния для модального окна выбора дат
  const [isDateModalOpen, setIsDateModalOpen] = useState<boolean>(false);
  const [dateModalRef, setDateModalRef] = useState<HTMLDivElement | null>(null);
  const [dateRangeType, setDateRangeType] = useState<string>('custom');

  // Календарь в модальном окне
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [nextMonth, setNextMonth] = useState(new Date(new Date().setMonth(new Date().getMonth() + 1)));
  const [tempStartDate, setTempStartDate] = useState<string>(singleDate || dateFrom);
  const [tempEndDate, setTempEndDate] = useState<string>(singleDate || dateTo);
  const [hoveredDate, setHoveredDate] = useState<Date | null>(null);

  // ==================== LOCALSTORAGE FUNCTIONS ====================
  
  const STORAGE_KEY = 'androidDashboardSettingsGoLiveAndroid';

  

  // Function to save all settings to localStorage
  const saveSettings = () => {
    try {
      const settings = {
        // Toggle states
        // Toggle states
isExplanationEnabled,
isFilterOpen,
showCountries,
showCampaigns,
showPChurn,
hideAllPeriods,
showPredictedRevenue,
showPCount,
showWithTax,
showEarlyPredicted,
distributeUnknowns,
        
        // Filters
        selectedCountries,
        selectedCampaigns,
        
        // Date settings
        dateFrom,
        dateTo,
        singleDate,
        useDateRange,
        viewMode,
        yearFrom,
        viewType,
        yearTo,
        monthFrom,
        monthTo,
        singleYear,
        singleMonth,
        
        // Other settings
        showPeriodColumns,
        
        
        // Save timestamp
        savedAt: new Date().toISOString()
      };
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
      console.log('Settings saved to localStorage');
    } catch (error) {
      console.error('Failed to save settings to localStorage:', error);
    }
  };


  const handleClearCountry = () => {
  setSelectedCountries([]); // или '', в зависимости от того, как ваш Select обрабатывает пустое значение
};

// НОВОЕ: Функция для очистки кампании
const handleClearCampaign = () => {
  setSelectedCampaigns([]); // или '',
};

  // Function to load settings from localStorage
  const loadSettings = () => {
    try {
      const savedSettings = localStorage.getItem(STORAGE_KEY);
      if (savedSettings) {
        const settings = JSON.parse(savedSettings);
        
        // Load toggle states
        setIsExplanationEnabled(settings.isExplanationEnabled ?? false);
        setIsFilterOpen(settings.isFilterOpen ?? true);
        setShowCountries(settings.showCountries ?? true);
        setShowCampaigns(settings.showCampaigns ?? true);
        setShowPChurn(settings.showPChurn ?? false);
        setHideP1ToP4(settings.hideP1ToP4 ?? false);
        setShowPeriodColumns(settings.showPeriodColumns ?? []);
        setShowPredictedRevenue(settings.showPredictedRevenue ?? false);
        setShowPCount(settings.showPCount ?? false);
        setShowWithTax(settings.showWithTax ?? true);
        setHideAllPeriods(settings.hideAllPeriods ?? true);
        setShowEarlyPredicted(settings.showEarlyPredicted ?? false);
setShowPlatform(settings.showPlatform ?? false);
setDistributeUnknowns(settings.distributeUnknowns ?? false);
        
        // Load filters
        setSelectedCountries(settings.selectedCountries ?? []);
        setSelectedCampaigns(settings.selectedCampaigns ?? []);
        setViewType(settings.viewType ?? 'table');
        // Load date settings
        setDateFrom(settings.dateFrom ?? getTodayDate());
        setDateTo(settings.dateTo ?? getTodayDate());
        setSingleDate(settings.singleDate ?? getTodayDate());
        setUseDateRange(settings.useDateRange ?? false);
        setViewMode(settings.viewMode ?? 'daily');
        setYearFrom(settings.yearFrom ?? new Date().getFullYear().toString());
        setYearTo(settings.yearTo ?? new Date().getFullYear().toString());
        setMonthFrom(settings.monthFrom ?? '1');
        setMonthTo(settings.monthTo ?? '12');
        setSingleYear(settings.singleYear ?? new Date().getFullYear().toString());
        setSingleMonth(settings.singleMonth ?? (new Date().getMonth() + 1).toString());
        
        // Load other settings
        setShowPeriodColumns(settings.showPeriodColumns ?? [5, 6, 7, 8, 9, 10, 11, 12]);
        
        console.log('Settings loaded from localStorage:', settings);
        return true;
      }
    } catch (error) {
      console.error('Failed to load settings from localStorage:', error);
    }
    return false;
  };

  // Function to clear saved settings
  const clearSavedSettings = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      console.log('Settings cleared from localStorage');
    } catch (error) {
      console.error('Failed to clear settings from localStorage:', error);
    }
  };



// Обновить существующий useEffect для закрытия модальных окон:
useEffect(() => {
  function handleClickOutside(event: MouseEvent) {
    if (countryModalRef.current && !countryModalRef.current.contains(event.target as Node)) {
      setIsCountryModalOpen(false);
    }
    if (campaignModalRef.current && !campaignModalRef.current.contains(event.target as Node)) {
      setIsCampaignModalOpen(false);
    }
    // ДОБАВИТЬ ЭТУ СТРОКУ:
    if (platformModalRef.current && !platformModalRef.current.contains(event.target as Node)) {
      setIsPlatformModalOpen(false);
    }
  }

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);

  // Load settings on component mount
  useEffect(() => {
  const timer = setTimeout(() => {
    saveSettings();
  }, 100);

  return () => clearTimeout(timer);
}, [
  isExplanationEnabled,
  isFilterOpen,
  showCountries,
  showCampaigns,
  showPChurn,
  showPlatform,
  hideAllPeriods,
  showPredictedRevenue,
  showPCount,
  showWithTax,
  showEarlyPredicted,
  distributeUnknowns,
  distributeDirect,
  selectedCountries,
  selectedCampaigns,
  selectedPlatforms,
  dateFrom,
  dateTo,
  singleDate,
  useDateRange,
  viewMode,
  yearFrom,
  yearTo,
  monthFrom,
  monthTo,
  singleYear,
  singleMonth,
  showPeriodColumns,
  viewType // ДОБАВИТЬ ЭТУ СТРОКУ
]);

  // ==================== END LOCALSTORAGE FUNCTIONS ====================

  // NEW: Function to get VAT rate for a country
 const getVatRate = (country: string): number => {
  return vatRates[country] !== undefined ? vatRates[country] : 0.0;
};



  // NEW: Function to calculate early predicted revenue for all periods
  // ЗАМЕНИТЬ СУЩЕСТВУЮЩУЮ calculateEarlyPredictedRevenue
const calculateEarlyPredictedRevenue = (item: OrderData, historicalCoefficients?: { [country: string]: number }): number => {
  const historicalCoef = historicalCoefficients?.[item.country] || 1;
  const revenueActivation = item.revenue_activation || 0;
  
  // Базовая часть: Revenue Activation + (Revenue Activation × исторический коэф)
  let totalEarlyPredicted = revenueActivation + (revenueActivation * historicalCoef);
  
  // Добавляем early_predicted_revenue_p1
  const enrichedItem = enrichOrderDataWithEarlyPredicted(item, historicalCoefficients);
  totalEarlyPredicted += enrichedItem.early_predicted_revenue_p1 as number || 0;
  
  // Добавляем цепочку с churn rates для P2-P12
  let previousEarlyPredicted = enrichedItem.early_predicted_revenue_p1 as number || 0;
  
  for (let i = 2; i <= 12; i++) {
    const churnKey = `predicted_churn_p${i}` as keyof OrderData;
    const churnValue = item[churnKey] as number | null;
    
    if (churnValue !== null && churnValue !== undefined) {
      const earlyPredictedValue = previousEarlyPredicted * churnValue;
      totalEarlyPredicted += earlyPredictedValue;
      previousEarlyPredicted = earlyPredictedValue;
    } else {
      break; // Прерываем цепочку если нет churn data
    }
  }
  
  return totalEarlyPredicted;
};

  // NEW: Function to calculate Early Predicted LTV
  const calculateEarlyPredictedLTV = (item: OrderData): number => {
    const earlyPredictedRevenue = calculateEarlyPredictedRevenue(item);
    const activationCount = item.count_unique_payers_activation || 0;
    return activationCount > 0 ? earlyPredictedRevenue / activationCount : 0;
  };

  // NEW: Function to calculate Early Predicted ROI
  const calculateEarlyPredictedROI = (item: OrderData): number => {
    const earlyPredictedRevenue = calculateEarlyPredictedRevenue(item);
    const costs = item.costs || 0;
    return costs > 0 ? ((earlyPredictedRevenue - costs) / costs) * 100 : 0;
  };

  // Function to toggle sorting when a header is clicked
  const toggleSort = (column: string) => {
    if (sortColumn === column) {
      // Cycle through: desc -> asc -> null
      if (sortDirection === 'desc') {
        setSortDirection('asc');
      } else if (sortDirection === 'asc') {
        setSortDirection(null);
        setSortColumn(null);
      } else {
        setSortDirection('desc');
      }
    } else {
      // New column selected, start with descending
      setSortColumn(column);
      setSortDirection('desc');
    }
  };

  // Function to get value for a specific column from an OrderData object
  // Function to get value for a specific column from an OrderData object
const getColumnValue = (item: OrderData, column: string): number => {
  switch(column) {
    case 'date':
      // Convert date to timestamp for sorting
      return new Date(item.date_activation).getTime();
    case 'revenue_activation':
      return getAdjustedRevenue(item.revenue_activation || 0, item.country);
    case 'costs':
      return item.costs || 0;
    case 'total_revenue':
      return calculateTotalRevenue(item);
    case 'profit':
      return calculateTotalRevenue(item) - (item.costs || 0);
    case 'roi':
      return calculateROI(item);
    case 'predicted_roi':
      return calculatePredictedROI(item);
    case 'early_predicted_roi':
      return calculateEarlyPredictedROI(item);
    case 'total_early_predicted_revenue':
      return calculateEarlyPredictedRevenue(item);
    case 'cpa_cost_per_action':
      return calculateCPA(item);
    case 'cpu_cost_per_user':
      return calculateCPU(item);
    default:
      return 0;
  }
};

  // Calculate sum of column values for a collection of OrderData items
  const sumColumnValues = (items: OrderData[], column: string): number => {
    return items.reduce((sum, item) => sum + getColumnValue(item, column), 0);
  };

  // NEW: Function to adjust revenue value based on VAT
  const getAdjustedRevenue = (value: number | null, country: string): number => {
    if (value === null) return 0;
    if (!showWithTax) return value;
    
    const vatRate = getVatRate(country);
    // ВАЖНО: Вычитаем налог, а не умножаем
    return value * (1 - vatRate);
  };

  // Функция для получения дат по предустановленному промежутку
  const getPresetDateRange = (presetType: string) => {
    const today = new Date();
    let startDate = new Date();
    let endDate = new Date();

    switch (presetType) {
      case 'last7days':
        startDate.setDate(today.getDate() - 6);
        break;
      case 'lastMonth':
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 'last28days':
        startDate.setDate(today.getDate() - 27);
        break;
      case 'last3months':
        startDate.setMonth(today.getMonth() - 3);
        break;
      case 'last6months':
        startDate.setMonth(today.getMonth() - 6);
        break;
      case 'lastYear':
        startDate.setFullYear(today.getFullYear() - 1);
        break;
      default:
        // Оставляем как есть
        break;
    }

    return {
      startDate: formatDateForAPI(startDate),
      endDate: formatDateForAPI(endDate)
    };
  };

  const [showInitialLoader, setShowInitialLoader] = useState<boolean>(true);

// Добавить этот useEffect после других useEffect
useEffect(() => {
  const timer = setTimeout(() => {
    setShowInitialLoader(false);
  }, 5000); // 3 секунды

  return () => clearTimeout(timer);
}, []);

  // Форматирование даты для API
  const formatDateForAPI = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Функции для работы с календарем
  const goToPreviousMonth = () => {
    const prevMonth = new Date(currentMonth);
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    setCurrentMonth(prevMonth);
    
    const nextPrevMonth = new Date(nextMonth);
    nextPrevMonth.setMonth(nextPrevMonth.getMonth() - 1);
    setNextMonth(nextPrevMonth);
  };

  const goToNextMonth = () => {
    const nextMonthDate = new Date(currentMonth);
    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
    setCurrentMonth(nextMonthDate);
    
    const nextNextMonth = new Date(nextMonth);
    nextNextMonth.setMonth(nextNextMonth.getMonth() + 1);
    setNextMonth(nextNextMonth);
  };

  // Генерация дней календаря
  const generateCalendarDays = (month: Date) => {
    const year = month.getFullYear();
    const monthIndex = month.getMonth();
    
    // Получаем первый день месяца
    const firstDay = new Date(year, monthIndex, 1);
    const startingDayOfWeek = firstDay.getDay(); // 0 = Воскресенье, 1 = Понедельник и т.д.
    
    // Получаем количество дней в месяце
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
    
    // Получаем количество дней в предыдущем месяце
    const daysInPrevMonth = new Date(year, monthIndex, 0).getDate();
    
    const days = [];
    
    // Добавляем дни из предыдущего месяца
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      const date = new Date(year, monthIndex - 1, daysInPrevMonth - i);
      days.push({
        date,
        isCurrentMonth: false,
      });
    }
    
    // Добавляем дни текущего месяца
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, monthIndex, i);
      days.push({
        date,
        isCurrentMonth: true,
      });
    }
    
    // Добавляем дни следующего месяца, чтобы заполнить оставшиеся ячейки
    const remainingSlots = 42 - days.length;
    for (let i = 1; i <= remainingSlots; i++) {
      const date = new Date(year, monthIndex + 1, i);
      days.push({
        date,
        isCurrentMonth: false,
      });
    }
    
    return days;
  };

  // Обработка выбора даты
  const handleDateClick = (date: Date) => {
    const formattedDate = formatDateForAPI(date);
    if (!tempStartDate || (tempStartDate && tempEndDate)) {
      // Начинаем новый выбор
      setTempStartDate(formattedDate);
      setTempEndDate('');
      setDateRangeType('custom');
    } else {
      // Завершаем выбор
      const startDateObj = new Date(tempStartDate);
      if (date < startDateObj) {
        setTempEndDate(tempStartDate);
        setTempStartDate(formattedDate);
      } else {
        setTempEndDate(formattedDate);
      }
    }
  };

  // Обработка наведения на дату
  const handleDateHover = (date: Date) => {
    if (tempStartDate && !tempEndDate) {
      setHoveredDate(date);
    }
  };

  // Проверка, находится ли дата в выбранном диапазоне
  const isInRange = (date: Date) => {
    if (!tempStartDate) return false;
    const startDateObj = new Date(tempStartDate);
    
    if (tempEndDate) {
      const endDateObj = new Date(tempEndDate);
      return date >= startDateObj && date <= endDateObj;
    }
    if (hoveredDate) {
      return (
        (date >= startDateObj && date <= hoveredDate) ||
        (date >= hoveredDate && date <= startDateObj)
      );
    }
    return false;
  };

  // Проверка, является ли дата одной из границ диапазона
  const isRangeEnd = (date: Date) => {
    if (!tempStartDate) return false;
    const startDateObj = new Date(tempStartDate);
    
    return (
      date.getTime() === startDateObj.getTime() ||
      (tempEndDate && date.getTime() === new Date(tempEndDate).getTime())
    );
  };

  // Применение выбранного диапазона дат
  const applyDateRange = () => {
    if (tempStartDate && tempEndDate) {
      if (useDateRange) {
        setDateFrom(tempStartDate);
        setDateTo(tempEndDate);
      } else {
        setSingleDate(tempStartDate);
      }
      setIsDateModalOpen(false);
    } else if (tempStartDate) {
      // Если выбрана только одна дата, используем её как для начала, так и для конца
      if (useDateRange) {
        setDateFrom(tempStartDate);
        setDateTo(tempStartDate);
      } else {
        setSingleDate(tempStartDate);
      }
      setIsDateModalOpen(false);
    }
  };

  // Отмена и закрытие модального окна
  const cancelDateSelection = () => {
    setTempStartDate(singleDate || dateFrom);
    setTempEndDate(singleDate || dateTo);
    setIsDateModalOpen(false);
  };

  // Выбор предустановленного периода
  const selectPresetRange = (presetType: string) => {
    setDateRangeType(presetType);
    
    if (presetType === 'custom') {
      return; // Для "Произвольного" не меняем даты
    }
    
    const { startDate, endDate } = getPresetDateRange(presetType);
    setTempStartDate(startDate);
    setTempEndDate(endDate);
    setUseDateRange(true);
  };

// ==================== PlatformModal с кнопкой Clear All ====================
interface PlatformModalProps {
  isOpen: boolean;
  onClose: () => void;
  allPlatforms: string[];
  allData: GroupedOrderData;
  initialSelection: string[];
  selectedCountries: string[];
  selectedCampaigns: string[];
  onApply: (selection: string[]) => void;
}


const handleSelectCampaign = (campaignName: string) => {
  // Добавляем кампанию к уже выбранным (если её там нет)
  if (!selectedCampaigns.includes(campaignName)) {
    setSelectedCampaigns(prev => [...prev, campaignName].sort());
  }
};

const PlatformModal: React.FC<PlatformModalProps> = ({
  isOpen, onClose, allPlatforms, allData, initialSelection,
  selectedCountries, selectedCampaigns, onApply
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);
  const [localSelection, setLocalSelection] = useState<string[]>(initialSelection);
  const [localSearch, setLocalSearch] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLocalSelection(initialSelection);
      setLocalSearch('');
      setTimeout(() => searchInputRef.current?.focus(), 50);
    }
  }, [isOpen, initialSelection]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const addPlatform = (platform: string) => setLocalSelection(prev => [...prev, platform].sort());
  const removePlatform = (platformToRemove: string) => setLocalSelection(prev => prev.filter(p => p !== platformToRemove));
  
  // НОВАЯ ФУНКЦИЯ: Очистить все выбранные платформы
  const clearAllPlatforms = () => setLocalSelection([]);

  const availablePlatforms = React.useMemo(() => {
    const validPlatforms = new Set<string>();

    if (selectedCountries.length === 0 && selectedCampaigns.length === 0) {
        allPlatforms.forEach(p => validPlatforms.add(p));
    } else {
        Object.values(allData).forEach(countriesByDate => {
            Object.entries(countriesByDate).forEach(([countryName, items]) => {
                if (selectedCountries.length > 0 && !selectedCountries.includes(countryName)) {
                    return;
                }
                items.forEach(item => {
                    if (item.platform && (selectedCampaigns.length === 0 || selectedCampaigns.includes(item.campaign))) {
                        validPlatforms.add(item.platform);
                    }
                });
            });
        });
    }
    
    return Array.from(validPlatforms)
      .filter(p => !localSelection.includes(p) && p.toLowerCase().includes(localSearch.toLowerCase()))
      .sort();
}, [allPlatforms, allData, localSelection, selectedCountries, selectedCampaigns, localSearch]);
  
  const handleToggleAll = () => {
    setLocalSelection(prev => Array.from(new Set([...prev, ...availablePlatforms])).sort());
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div ref={modalRef} className="modal-content" style={{ backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '800px', height: '80vh', padding: '20px', boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexShrink: 0 }}>
          <h3 style={{ margin: 0, color: '#2c3e50' }}>Select Platforms</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6c757d' }}><X size={20} /></button>
        </div>
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden', gap: '20px' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <div style={{ position: 'relative', marginBottom: '15px', flexShrink: 0 }}>
              <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d' }} size={16} />
              <input ref={searchInputRef} type="text" style={{ padding: '10px 10px 10px 36px', border: '1px solid #dee2e6', borderRadius: '6px', width: '100%', fontSize: '14px' }} placeholder="Search available platforms..." value={localSearch} onChange={(e) => setLocalSearch(e.target.value)} />
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #e9ecef', cursor: 'pointer' }} onClick={handleToggleAll}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', border: '1px solid #dee2e6', borderRadius: '4px', marginRight: '10px' }} />
                <span style={{ fontWeight: 500 }}>Select All Visible</span>
              </div>
              {availablePlatforms.length > 0 ? (
                availablePlatforms.map(p => <div key={p} onClick={() => addPlatform(p)} style={{ display: 'flex', alignItems: 'center', padding: '10px 0', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', border: '1px solid #dee2e6', borderRadius: '4px', marginRight: '10px' }} /><span>{p}</span></div>)
              ) : (
                <div style={{ padding: '15px 0', textAlign: 'center', color: '#6c757d' }}>No available platforms</div>
              )}
            </div>
          </div>
          <div style={{ width: '300px', border: '1px solid #dee2e6', borderRadius: '8px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px', borderBottom: '1px solid #dee2e6', flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h5 style={{ margin: 0, color: '#495057' }}>Selected ({localSelection.length})</h5>
              {/* НОВАЯ КНОПКА Clear All */}
              {localSelection.length > 0 && (
                <button 
                  onClick={clearAllPlatforms}
                  style={{
                    padding: '4px 8px',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    color: '#dc3545',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 500,
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#dc3545';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#fff';
                    e.currentTarget.style.color = '#dc3545';
                  }}
                >
                  Clear All
                </button>
              )}
            </div>
            <div style={{ overflowY: 'auto', flex: 1, padding: '4px' }}>
              {localSelection.length > 0 ? (
                localSelection.map(p => <FilterChip key={`chip-${p}`} label={p} onRemove={removePlatform} />)
              ) : (
                <div style={{ padding: '15px', textAlign: 'center', color: '#adb5bd', fontSize: '14px' }}>Click on a platform to add it here.</div>
              )}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', borderTop: '1px solid #e9ecef', paddingTop: '15px', marginTop: '15px', flexShrink: 0 }}>
          <button onClick={onClose} style={{ padding: '8px 16px', border: '1px solid #dee2e6', borderRadius: '6px', backgroundColor: '#f8f9fa', cursor: 'pointer', color: '#495057' }}>Cancel</button>
          <button onClick={() => onApply(localSelection)} style={{ padding: '8px 16px', border: 'none', borderRadius: '6px', backgroundColor: '#3498db', cursor: 'pointer', color: 'white', fontWeight: 500 }}>Apply</button>
        </div>
      </div>
    </div>
  );
};

  // Модальное окно выбора дат
  const DateRangeModal: React.FC = () => {
    if (!isDateModalOpen) return null;
    
    const dayNames = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
    
    return (
      <div className="modal-overlay" style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}>
        <div
          ref={setDateModalRef}
          className="modal-content"
          style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '700px',
            maxHeight: '85vh',
            padding: '20px',
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
          }}
        >
          {/* Заголовок */}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
          }}>
            <h3 style={{ margin: 0, color: '#2c3e50' }}>Выберите период</h3>
            <button
              onClick={() => setIsDateModalOpen(false)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#6c757d',
              }}
            >
              <X size={20} />
            </button>
          </div>
          
          {/* Содержимое */}
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '20px',
          }}>
            {/* Левая сторона - пресеты */}
            <div style={{
              width: '200px',
              borderRight: '1px solid #e9ecef',
              paddingRight: '20px',
            }}>
              <h4 style={{ marginTop: 0, color: '#495057' }}>Предустановленные периоды</h4>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
              }}>
                <li
                  onClick={() => selectPresetRange('last7days')}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: dateRangeType === 'last7days' ? '#e9ecef' : 'transparent',
                    borderRadius: '4px',
                    marginBottom: '5px',
                  }}
                >
                  Последние 7 дней
                </li>
                <li
                  onClick={() => selectPresetRange('lastMonth')}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: dateRangeType === 'lastMonth' ? '#e9ecef' : 'transparent',
                    borderRadius: '4px',
                    marginBottom: '5px',
                  }}
                >
                  Прошлый месяц
                </li>
                <li
                  onClick={() => selectPresetRange('last28days')}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: dateRangeType === 'last28days' ? '#e9ecef' : 'transparent',
                    borderRadius: '4px',
                    marginBottom: '5px',
                  }}
                >
                  Последние 28 дней
                </li>
                <li
                  onClick={() => selectPresetRange('last3months')}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: dateRangeType === 'last3months' ? '#e9ecef' : 'transparent',
                    borderRadius: '4px',
                    marginBottom: '5px',
                  }}
                >
                  Последние 3 месяца
                </li>
                <li
                  onClick={() => selectPresetRange('last6months')}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: dateRangeType === 'last6months' ? '#e9ecef' : 'transparent',
                    borderRadius: '4px',
                    marginBottom: '5px',
                  }}
                >
                  Последние 6 месяцев
                </li>
                <li
                  onClick={() => selectPresetRange('lastYear')}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: dateRangeType === 'lastYear' ? '#e9ecef' : 'transparent',
                    borderRadius: '4px',
                    marginBottom: '5px',
                  }}
                >
                  Последний год
                </li>
                <li
                  onClick={() => selectPresetRange('custom')}
                  style={{
                    padding: '10px',
                    cursor: 'pointer',
                    backgroundColor: dateRangeType === 'custom' ? '#e9ecef' : 'transparent',
                    borderRadius: '4px',
                    marginBottom: '5px',
                  }}
                >
                  Произвольный период
                </li>
              </ul>
            </div>
            
            {/* Правая сторона - календарь и поля ввода */}
            <div style={{ flex: 1 }}>
              {/* Поля ввода дат */}
              <div style={{
                display: 'flex',
                gap: '10px',
                marginBottom: '20px',
              }}>
                <div style={{ flex: 1 }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '5px',
                    fontSize: '14px',
                    color: '#495057',
                  }}>
                    Начало периода
                  </label>
                  <input
                    type="date"
                    value={tempStartDate}
                    onChange={(e) => setTempStartDate(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: '1px solid #dee2e6',
                      borderRadius: '4px',
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{
                    display: 'block',
                    marginBottom: '5px',
                    fontSize: '14px',
                    color: '#495057',
                  }}>
                    Конец периода
                  </label>
                  <input
                    type="date"
                    value={tempEndDate}
                    onChange={(e) => setTempEndDate(e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: '1px solid #dee2e6',
                      borderRadius: '4px',
                    }}
                  />
                </div>
              </div>
              
              {/* Календарь */}
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
                flexWrap: 'wrap',
              }}>
                {/* Первый месяц */}
                <div style={{ minWidth: '280px', flex: 1 }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                  }}>
                    <button
                      onClick={goToPreviousMonth}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#6c757d',
                      }}
                    >
                      <ArrowLeft size={16} />
                    </button>
                    <span style={{ fontWeight: 500 }}>
                      {currentMonth.toLocaleDateString('ru-RU', {
                        month: 'long',
                        year: 'numeric',
                      })}
                    </span>
                    <div style={{ width: '16px' }}></div> {/* Распорка для выравнивания */}
                  </div>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '2px',
                  }}>
                    {/* Заголовки дней */}
                    {dayNames.map((day) => (
                      <div
                        key={day}
                        style={{
                          textAlign: 'center',
                          padding: '5px',
                          fontSize: '12px',
                          fontWeight: 500,
                          color: '#6c757d',
                        }}
                      >
                        {day}
                      </div>
                    ))}
                    
                    {/* Дни календаря */}
                    {generateCalendarDays(currentMonth).map((day, index) => (
                      <div
                        key={`current-${index}`}
                        onClick={() => handleDateClick(day.date)}
                        onMouseEnter={() => handleDateHover(day.date)}
                        style={{
                          textAlign: 'center',
                          padding: '8px 5px',
                          cursor: 'pointer',
                          backgroundColor: isRangeEnd(day.date)
                            ? '#3498db'
                            : isInRange(day.date)
                            ? '#e1f0fa'
                            : 'transparent',
                          color: isRangeEnd(day.date)
                            ? 'white'
                            : !day.isCurrentMonth
                            ? '#adb5bd'
                            : '#495057',
                          borderRadius: '4px',
                          fontWeight: isRangeEnd(day.date) ? 500 : 'normal',
                        }}
                      >
                        {day.date.getDate()}
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Второй месяц */}
                <div style={{ minWidth: '280px', flex: 1 }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px',
                  }}>
                    <div style={{ width: '16px' }}></div> {/* Распорка для выравнивания */}
                    <span style={{ fontWeight: 500 }}>
                      {nextMonth.toLocaleDateString('ru-RU', {
                        month: 'long',
                        year: 'numeric',
                      })}
                    </span>
                    <button
                      onClick={goToNextMonth}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#6c757d',
                      }}
                    >
                      <ArrowRight size={16} />
                    </button>
                  </div>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(7, 1fr)',
                    gap: '2px',
                  }}>
                    {/* Заголовки дней */}
                    {dayNames.map((day) => (
                      <div
                        key={day}
                        style={{
                          textAlign: 'center',
                          padding: '5px',
                          fontSize: '12px',
                          fontWeight: 500,
                          color: '#6c757d',
                        }}
                      >
                        {day}
                      </div>
                    ))}
                    
                    {/* Дни календаря */}
                    {generateCalendarDays(nextMonth).map((day, index) => (
                      <div
                        key={`next-${index}`}
                        onClick={() => handleDateClick(day.date)}
                        onMouseEnter={() => handleDateHover(day.date)}
                        style={{
                          textAlign: 'center',
                          padding: '8px 5px',
                          cursor: 'pointer',
                          backgroundColor: isRangeEnd(day.date)
                            ? '#3498db'
                            : isInRange(day.date)
                            ? '#e1f0fa'
                            : 'transparent',
                          color: isRangeEnd(day.date)
                            ? 'white'
                            : !day.isCurrentMonth
                            ? '#adb5bd'
                            : '#495057',
                          borderRadius: '4px',
                          fontWeight: isRangeEnd(day.date) ? 500 : 'normal',
                        }}
                      >
                        {day.date.getDate()}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Нижняя панель с кнопками */}
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px',
            padding: '15px 0 0',
            borderTop: '1px solid #e9ecef',
            gap: '10px',
          }}>
            <button
              onClick={cancelDateSelection}
              style={{
                padding: '8px 16px',
                border: '1px solid #dee2e6',
                borderRadius: '4px',
                backgroundColor: '#f8f9fa',
                cursor: 'pointer',
              }}
            >
              Отмена
            </button>
            <button
              onClick={applyDateRange}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '4px',
                backgroundColor: tempStartDate ? '#3498db' : '#adb5bd',
                color: 'white',
                cursor: tempStartDate ? 'pointer' : 'not-allowed',
              }}
            >
              Применить
            </button>
          </div>
        </div>
      </div>
    );
  };



  
  
  // Function to calculate Total Revenue with VAT adjustment
  // --> СКОПИРУЙТЕ И ЗАМЕНИТЕ ЭТУ ФУНКЦИЮ В AndroidDashboardPage.tsx

    // ИСПРАВЛЕННАЯ ФУНКЦИЯ: Правильно считает Total Revenue из компонентов
  // ИСПРАВЛЕННАЯ ФУНКЦИЯ: Доверяем данным с бэкенда
const calculateTotalRevenue = (item: OrderData): number => {
  // Просто используем поле total_revenue, которое теперь корректно считает бэкенд.
  const backendTotalRevenue = item.total_revenue || 0;
  
  // Применяем корректировку VAT, если нужно.
  return getAdjustedRevenue(backendTotalRevenue, item.country);
};

  // Function to calculate total predicted revenue
  const calculateTotalPredictedRevenue = (item: OrderData): number => {
    let total = getAdjustedRevenue(item.revenue_activation || 0, item.country);
    
    // Add revenue_activation_purchase if available
    if (item.revenue_activation_purchase) { // <-- Обратите внимание: поле без _count
  total += getAdjustedRevenue(item.revenue_activation_purchase, item.country);
}
    
    // Add all predicted_revenue_p* values
    for (let i = 1; i <= 24; i++) {
      const key = `predicted_revenue_p${i}` as keyof OrderData;
      const value = item[key] as number | null | undefined;
      
      if (value !== null && value !== undefined) {
        total += getAdjustedRevenue(value, item.country);
      }
    }
    
    return total;
  };

  const calculatePredictedLTV = (item: OrderData): number => {
    const predictedRevenue = calculatePredictedRevenue2(item);
    const activationCount = item.count_unique_payers_activation || 0;
    return activationCount > 0 ? predictedRevenue / activationCount : 0;
  };
  
  const calculatePredictedRevenue2 = (item: OrderData): number => {
    // Use the existing total_predicted_revenue if available
    if (item.total_predicted_revenue !== null && item.total_predicted_revenue !== undefined) {
      return getAdjustedRevenue(item.total_predicted_revenue, item.country);
    }
    
    // Otherwise calculate it
    return calculateTotalPredictedRevenue(item);
  };

  const calculatePredictedROI = (item: OrderData): number => {
    const predictedRevenue = calculatePredictedRevenue2(item);
    const costs = item.costs || 0;
    return costs > 0 ? ((predictedRevenue - costs) / costs) * 100 : 0;
  };

  // Calculate churn rate for a specific period
  const calculateChurnRate = (item: OrderData, periodNum: number): string => {
    const activationCount = item.revenue_activation_count || 0;
    if (activationCount === 0) return '0.00%';
    
    const periodCountKey = `revenue_p${periodNum}_count` as keyof OrderData;
    const periodCount = item[periodCountKey] as number | null;
    
    if (periodCount === null || periodCount === 0) return '0.00%';
    
    // Calculate percentage of users retained from activation to this period
    const churnRate = (periodCount / activationCount) * 100;
    return churnRate.toFixed(2) + '%';
  };

  // NEW: Fetch VAT rates when component loads or when show with tax changes
useEffect(() => {
  const fetchVatRates = async () => {
    try {
      const response = await axios.get('https://dashboard-nk.golive.mobi/api/api/vat');
      if (response.data.success) {
        const rates: { [country: string]: number } = {};
        response.data.data.forEach((item: { country: string, VAT: number }) => {
          rates[item.country] = item.VAT;
        });
        
        // Обновляем состояние VAT-ставок
        setVatRates(rates);
        
        // Дополнительная отладочная информация
        console.log('Fetched VAT Rates:', rates);
      } else {
        console.error('VAT rates fetch was not successful');
      }
    } catch (err) {
      console.error('Failed to fetch VAT rates:', err);
      
      // Опциональная обработка ошибок - можно установить дефолтные значения
      const defaultRates: { [country: string]: number } = {};
      setVatRates(defaultRates);
    } finally {
      // Можно добавить какие-то действия, которые нужно выполнить в любом случае
    }
  };
  
  // Вызываем функцию загрузки VAT-ставок
  fetchVatRates();
}, [showWithTax]); // Добавляем showWithTax как зависимость

  // Закрытие модальных окон при клике вне их области
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (countryModalRef.current && !countryModalRef.current.contains(event.target as Node)) {
        setIsCountryModalOpen(false);
      }
      if (campaignModalRef.current && !campaignModalRef.current.contains(event.target as Node)) {
        setIsCampaignModalOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);





  // Добавьте эту обновленную версию renderCountryPeriodValuesWithPredicted:

const renderCountryPeriodValuesWithPredicted = (countrySummary: OrderData) => {
  if (hideAllPeriods) return []; // если скрыты все периоды, возвращаем пустой массив
  
  const periodValues = [];
  const startPeriod = 1;
  
  // Получаем текущую дату из countrySummary
  const currentDate = countrySummary.date_activation;
  
  // Получаем данные только для текущей даты
  const currentDateData = ordersData[currentDate] || {};
  
  for (let i = startPeriod; i <= 12; i++) {
    const periodKey = `revenue_p${i}` as keyof OrderData;
    const countKey = `revenue_p${i}_count` as keyof OrderData;
    
    // Аналогичная логика фильтрации как в Revenue Activation
    const totalRevenueValue = (() => {
    if (selectedCampaigns.length > 0 || selectedPlatforms.length > 0) {
      return Object.values(currentDateData).flatMap(countryItems => 
        countryItems.filter(item => 
          (selectedCampaigns.length === 0 || selectedCampaigns.includes(item.campaign)) &&
          (selectedPlatforms.length === 0 || selectedPlatforms.includes(item.platform || '---'))
        ).reduce((sum, item) => {
          const value = item[periodKey] as number | null;
          const adjustedValue = showWithTax && value !== null 
            ? value * (1 - getVatRate(item.country)) 
            : (value || 0);
          return sum + adjustedValue;
        }, 0)
      ).reduce((a, b) => a + b, 0);
      } else {
        // Если кампании не выбраны, используем все данные
        return Object.values(currentDateData).flatMap(countryItems => 
          countryItems.reduce((sum, item) => {
            const value = item[periodKey] as number | null;
            const adjustedValue = showWithTax && value !== null 
              ? value * (1 - getVatRate(item.country)) 
              : (value || 0);
            return sum + adjustedValue;
          }, 0)
        ).reduce((a, b) => a + b, 0);
      }
    })();
    
    periodValues.push(
      renderCell(
        countrySummary,
        periodKey,
        totalRevenueValue.toFixed(2),
        `Total Revenue for Period ${i}`
      )
    );
    
    // Добавляем столбец Churn, если включен
    if (showPChurn) {
      // Аналогично используем фильтрацию по кампаниям для Churn
      const totalChurnRate = (() => {
        const filteredItems = selectedCampaigns.length > 0
          ? Object.values(currentDateData).flatMap(countryItems => 
              countryItems.filter(item => selectedCampaigns.includes(item.campaign)))
          : Object.values(currentDateData).flatMap(countryItems => countryItems);
          
        if (filteredItems.length === 0) return 0;
        
        return filteredItems
          .map(item => {
            const activationCount = item.revenue_activation_count || 0;
            const periodCountKey = `revenue_p${i}_count` as keyof OrderData;
            const periodCount = item[periodCountKey] as number | null || 0;
            return activationCount > 0 ? (periodCount / activationCount) * 100 : 0;
          })
          .reduce((a, b) => a + b, 0) / filteredItems.length;
      })();
      
      periodValues.push(
        renderCell(
          countrySummary,
          `p${i}_churn`,
          totalChurnRate.toFixed(2) + '%',
          `Aggregate Churn Rate for Period ${i}`
        )
      );
    }
    
    // Добавляем столбец Count, если включен
    if (showPCount) {
      // Аналогично используем фильтрацию по кампаниям для Count
      const totalCount = (() => {
        if (selectedCampaigns.length > 0) {
          return Object.values(currentDateData).flatMap(countryItems => 
            countryItems.filter(item => selectedCampaigns.includes(item.campaign))
              .reduce((sum, item) => {
                const periodCountKey = `revenue_p${i}_count` as keyof OrderData;
                const count = item[periodCountKey] as number | null;
                return sum + (count || 0);
              }, 0)
          ).reduce((a, b) => a + b, 0);
        } else {
          return Object.values(currentDateData).flatMap(countryItems => 
            countryItems.reduce((sum, item) => {
              const periodCountKey = `revenue_p${i}_count` as keyof OrderData;
              const count = item[periodCountKey] as number | null;
              return sum + (count || 0);
            }, 0)
          ).reduce((a, b) => a + b, 0);
        }
      })();
      
      periodValues.push(
        renderCell(
          countrySummary,
          `revenue_p${i}_count`,
          totalCount.toString(),
          `Total Count for Period ${i}`
        )
      );
    }

    // Добавляем столбец predicted revenue, если включен
    if (showPredictedRevenue) {
      const predictedKey = `predicted_revenue_p${i}` as keyof OrderData;
      
      // Аналогично используем фильтрацию по кампаниям для Predicted Revenue
      const totalPredictedRevenue = (() => {
        if (selectedCampaigns.length > 0) {
          return Object.values(currentDateData).flatMap(countryItems => 
            countryItems.filter(item => selectedCampaigns.includes(item.campaign))
              .reduce((sum, item) => {
                const value = item[predictedKey] as number | null;
                const adjustedValue = showWithTax && value !== null 
                  ? value * (1 - getVatRate(item.country)) 
                  : (value || 0);
                return sum + adjustedValue;
              }, 0)
          ).reduce((a, b) => a + b, 0);
        } else {
          return Object.values(currentDateData).flatMap(countryItems => 
            countryItems.reduce((sum, item) => {
              const value = item[predictedKey] as number | null;
              const adjustedValue = showWithTax && value !== null 
                ? value * (1 - getVatRate(item.country)) 
                : (value || 0);
              return sum + adjustedValue;
            }, 0)
          ).reduce((a, b) => a + b, 0);
        }
      })();
      
      periodValues.push(
        renderCell(
          countrySummary,
          predictedKey,
          totalPredictedRevenue.toFixed(2),
          `Total Predicted Revenue for Period ${i}`
        )
      );
    }

    // NEW: Добавляем столбец early predicted revenue, если включен
    if (showEarlyPredicted) {
      // Рассчитываем total early predicted revenue для этого периода
      const totalEarlyPredictedRevenue = (() => {
        const filteredItems = selectedCampaigns.length > 0
          ? Object.values(currentDateData).flatMap(countryItems => 
              countryItems.filter(item => selectedCampaigns.includes(item.campaign)))
          : Object.values(currentDateData).flatMap(countryItems => countryItems);
        
        return filteredItems.reduce((sum, item) => {
          const enrichedItem = enrichOrderDataWithEarlyPredicted(item, historicalCoefficients);
          const earlyPredictedKey = `early_predicted_revenue_p${i}` as keyof OrderData;
          const value = enrichedItem[earlyPredictedKey] as number | null;
          const adjustedValue = showWithTax && value !== null 
            ? value * (1 - getVatRate(item.country)) 
            : (value || 0);
          return sum + adjustedValue;
        }, 0);
      })();
      
      periodValues.push(
        renderCell(
          countrySummary,
          `early_predicted_revenue_p${i}`,
          totalEarlyPredictedRevenue.toFixed(2),
          `Total Early Predicted Revenue for Period ${i}`
        )
      );
    }
  }
  return periodValues;
};




  // Замените существующую функцию renderCountryPeriodValuesWithPredicted2 на эту:

// ЗАМЕНИТЬ СУЩЕСТВУЮЩУЮ renderCountryPeriodValuesWithPredicted2 на эту:

const renderCountryPeriodValuesWithPredicted2 = (countrySummary: OrderData) => {
  if (hideAllPeriods) return []; // если скрыты все периоды, возвращаем пустой массив
  
  const periodValues = [];
  const startPeriod = 1;
  
  // Получаем VAT-ставку для страны
  const vatRate = showWithTax ? getVatRate(countrySummary.country) : 0;
  
  // НЕ ИСПОЛЬЗУЕМ enrichOrderDataWithEarlyPredicted для агрегированных данных!
  // Используем уже предрассчитанные значения из countrySummary
  
  for (let i = startPeriod; i <= 12; i++) {
    const periodKey = `revenue_p${i}` as keyof OrderData;
    const countKey = `revenue_p${i}_count` as keyof OrderData;
    
    // Получаем значение и применяем VAT корректировку
    const revenueValue = countrySummary[periodKey] as number | null;
    const adjustedValue = (showWithTax && revenueValue !== null) 
      ? revenueValue * (1 - vatRate)  // Прямое вычисление VAT
      : revenueValue;
    
    periodValues.push(
      renderCell(
        countrySummary,
        periodKey,
        adjustedValue !== null 
          ? (typeof adjustedValue === 'number' ? adjustedValue.toFixed(2) : adjustedValue)
          : '0.00',
        `Sum of Revenue Period ${i} for ${countrySummary.country}`
      )
    );
    
    // Добавляем столбец Churn, если включен
    if (showPChurn) {
      const activationCount = countrySummary.revenue_activation_count || 0;
      const periodCount = countrySummary[countKey] as number | null || 0;
      const churnRate = activationCount > 0 ? (periodCount / activationCount) * 100 : 0;
      
      periodValues.push(
        renderCell(
          countrySummary,
          `p${i}_churn`,
          churnRate.toFixed(2) + '%',
          `Aggregate Churn Rate for Period ${i} in ${countrySummary.country}`
        )
      );
    }
    
    // Добавляем столбец Count, если включен
    if (showPCount) {
      periodValues.push(
        renderCell(
          countrySummary,
          countKey,
          countrySummary[countKey] !== null ? countrySummary[countKey] : '0',
          `Sum of Count for Period ${i} in ${countrySummary.country}`
        )
      );
    }

    // Добавляем столбец predicted revenue, если включен
    if (showPredictedRevenue) {
      const predictedKey = `predicted_revenue_p${i}` as keyof OrderData;
      const predictedValue = countrySummary[predictedKey];
      const adjustedPredictedValue = (showWithTax && predictedValue !== null && predictedValue !== undefined) 
        ? (predictedValue as number) * (1 - vatRate)  // Прямое вычисление VAT
        : predictedValue;
          
      periodValues.push(
        renderCell(
          countrySummary,
          predictedKey,
          adjustedPredictedValue !== null 
            ? (typeof adjustedPredictedValue === 'number' ? adjustedPredictedValue.toFixed(2) : adjustedPredictedValue)
            : '0.00',
          `Sum of Predicted Revenue Period ${i} for ${countrySummary.country}`
        )
      );
    }

    // NEW: Добавляем столбец early predicted revenue, если включен
    if (showEarlyPredicted) {
      const earlyPredictedKey = `early_predicted_revenue_p${i}` as keyof OrderData;
      // КЛЮЧЕВОЕ ИЗМЕНЕНИЕ: используем уже предрассчитанное значение из countrySummary
      const earlyPredictedValue = countrySummary[earlyPredictedKey];
      const adjustedEarlyPredictedValue = (showWithTax && earlyPredictedValue !== null && earlyPredictedValue !== undefined) 
        ? (earlyPredictedValue as number) * (1 - vatRate)  // Прямое вычисление VAT
        : earlyPredictedValue;
          
      periodValues.push(
        renderCell(
          countrySummary,
          earlyPredictedKey,
          adjustedEarlyPredictedValue !== null 
            ? (typeof adjustedEarlyPredictedValue === 'number' ? adjustedEarlyPredictedValue.toFixed(2) : adjustedEarlyPredictedValue)
            : '0.00',
          `Sum of Early Predicted Revenue Period ${i} for ${countrySummary.country}`
        )
      );
    }
  }
  return periodValues;
};

  const calculatePredictedRevenue = (item: OrderData): (number | null)[] => {
    const predictedRevenueArray: (number | null)[] = [];
    
    // Predicted Revenue P1 всегда равен значению revenue_p1
    predictedRevenueArray[0] = item.revenue_p1 || 0;
  
    // Расчет для P2-P12
    for (let i = 2; i <= 12; i++) {
      const prevPredictedRevenue = predictedRevenueArray[i - 2];
      const churnKey = `predicted_churn_p${i}` as keyof OrderData;
      const churnValue = item[churnKey];
  
      // Если предыдущий predicted revenue или churn равен null, то текущий тоже null
      if (prevPredictedRevenue === null || churnValue === null || churnValue === undefined) {
        predictedRevenueArray[i - 1] = null;
      } else {
        // Просто умножаем предыдущий predicted revenue на churn
        predictedRevenueArray[i - 1] = prevPredictedRevenue * (churnValue as number);
      }
    }
  
    return predictedRevenueArray;
  };

  // Добавьте эту функцию после calculatePredictedRevenue:

// ЗАМЕНИТЬ СУЩЕСТВУЮЩУЮ calculateEarlyPredictedRevenueArray
// ЗАМЕНИТЬ СУЩЕСТВУЮЩУЮ calculateEarlyPredictedRevenueArray
// ИСПРАВЛЕННАЯ calculateEarlyPredictedRevenueArray
const calculateEarlyPredictedRevenueArray = (item: OrderData, historicalCoef: number): (number | null)[] => {
  const earlyPredictedRevenueArray: (number | null)[] = [];
  
  // P1: Early Predicted Revenue P1 = revenue_p1 (фактическое значение)
  earlyPredictedRevenueArray[0] = item.revenue_p1 || 0;

  // P2-P12: Цепочка с churn rates
  for (let i = 2; i <= 12; i++) {
    const prevEarlyPredictedRevenue = earlyPredictedRevenueArray[i - 2];
    const churnKey = `predicted_churn_p${i}` as keyof OrderData;
    const churnValue = item[churnKey];

    if (prevEarlyPredictedRevenue === null || churnValue === null || churnValue === undefined) {
      earlyPredictedRevenueArray[i - 1] = null;
    } else {
      earlyPredictedRevenueArray[i - 1] = prevEarlyPredictedRevenue * (churnValue as number);
    }
  }

  return earlyPredictedRevenueArray;
};

// ВСТАВИТЬ ПОСЛЕ calculateEarlyPredictedRevenueArray
const calculateHistoricalCoefficients = (ordersData: GroupedOrderData): { [country: string]: number } => {
  const countryStats: { [country: string]: { totalRevenue: number, totalActivation: number } } = {};
  
  // Собираем статистику по каждой стране
  Object.values(ordersData).forEach(dateData => {
    Object.entries(dateData).forEach(([country, items]) => {
      if (!countryStats[country]) {
        countryStats[country] = { totalRevenue: 0, totalActivation: 0 };
      }
      
      items.forEach(item => {
        countryStats[country].totalRevenue += item.total_revenue || 0;
        countryStats[country].totalActivation += item.revenue_activation || 0;
      });
    });
  });
  
  // Рассчитываем коэффициенты
  const coefficients: { [country: string]: number } = {};
  Object.entries(countryStats).forEach(([country, stats]) => {
    coefficients[country] = stats.totalActivation > 0 
      ? stats.totalRevenue / stats.totalActivation 
      : 1; // По умолчанию 1, если нет данных
  });
  
  return coefficients;
};

// Добавьте эту функцию после calculateEarlyPredictedRevenueArray:

// ЗАМЕНИТЬ СУЩЕСТВУЮЩУЮ enrichOrderDataWithEarlyPredicted
const enrichOrderDataWithEarlyPredicted = (item: OrderData, historicalCoefficients?: { [country: string]: number }): OrderData => {
  const historicalCoef = historicalCoefficients?.[item.country] || 1;
  const earlyPredictedArray = calculateEarlyPredictedRevenueArray(item, historicalCoef);
  
  const enrichedItem = { ...item };
  
  // Заполняем поля early_predicted_revenue_p1 до p12
  for (let i = 1; i <= 12; i++) {
    const fieldKey = `early_predicted_revenue_p${i}` as keyof OrderData;
    (enrichedItem[fieldKey] as any) = earlyPredictedArray[i - 1];
  }
  
  return enrichedItem;
};



  // Render both actual and predicted period values with VAT adjustment
  // Замените существующую функцию renderPeriodValuesWithPredicted на эту:

const renderPeriodValuesWithPredicted = (item: OrderData) => {
  if (hideAllPeriods) return []; // если скрыты все периоды, возвращаем пустой массив
  
  const periodValues = [];
  const startPeriod = 1;
  
  // Обогащаем item early predicted значениями
  const enrichedItem = enrichOrderDataWithEarlyPredicted(item, historicalCoefficients);
  
  for (let i = startPeriod; i <= 12; i++) {
    const periodKey = `revenue_p${i}` as keyof OrderData;
    const countKey = `revenue_p${i}_count` as keyof OrderData;
    const value = enrichedItem[periodKey];
    
    // Применяем корректировку VAT только если включен showWithTax
    const adjustedValue = (showWithTax && value !== null) 
      ? getAdjustedRevenue(value as number, enrichedItem.country) 
      : value;
    
    periodValues.push(
      renderCell(
        enrichedItem, 
        periodKey,
        adjustedValue !== null 
          ? (typeof adjustedValue === 'number' ? adjustedValue.toFixed(2) : adjustedValue)
          : '—',
        `Revenue Period ${i}`,
        i
      )
    );
    
    // Conditionally add churn column
    if (showPChurn) {
      periodValues.push(
        renderCell(
          enrichedItem,
          `p${i}_churn`,
          calculateChurnRate(enrichedItem, i),
          `Churn Rate for Period ${i}`
        )
      );
    }
    
    // Conditionally add count column
    if (showPCount) {
      const countValue = enrichedItem[countKey];
      periodValues.push(
        renderCell(
          enrichedItem,
          countKey,
          countValue !== null ? countValue : '—',
          `Count for Period ${i}`
        )
      );
    }
    
    // Conditionally add predicted revenue column
    if (showPredictedRevenue) {
      const predictedPeriodKey = `predicted_revenue_p${i}` as keyof OrderData;
      const predictedValue = enrichedItem[predictedPeriodKey];
      
      // Применяем корректировку VAT только если включен showWithTax
      const adjustedPredictedValue = (showWithTax && predictedValue !== null && predictedValue !== undefined) 
        ? getAdjustedRevenue(predictedValue as number, enrichedItem.country) 
        : predictedValue;
      
      periodValues.push(
        renderCell(
          enrichedItem,
          predictedPeriodKey,
          adjustedPredictedValue !== null 
            ? (typeof adjustedPredictedValue === 'number' ? adjustedPredictedValue.toFixed(2) : adjustedPredictedValue)
            : '—',
          `Predicted Revenue Period ${i}`,
          i
        )
      );
    }

    // NEW: Conditionally add early predicted revenue column
    if (showEarlyPredicted) {
      const earlyPredictedPeriodKey = `early_predicted_revenue_p${i}` as keyof OrderData;
      const earlyPredictedValue = enrichedItem[earlyPredictedPeriodKey];
      
      // Применяем корректировку VAT только если включен showWithTax
      const adjustedEarlyPredictedValue = (showWithTax && earlyPredictedValue !== null && earlyPredictedValue !== undefined) 
        ? getAdjustedRevenue(earlyPredictedValue as number, enrichedItem.country) 
        : earlyPredictedValue;
      
      periodValues.push(
        renderCell(
          enrichedItem,
          earlyPredictedPeriodKey,
          adjustedEarlyPredictedValue !== null 
            ? (typeof adjustedEarlyPredictedValue === 'number' ? adjustedEarlyPredictedValue.toFixed(2) : adjustedEarlyPredictedValue)
            : '—',
          `Early Predicted Revenue Period ${i}`,
          i
        )
      );
    }
  }
  return periodValues;
};

// Generate column headers for periods with predicted revenue option
// Замените существующую функцию renderPeriodColumns на эту:

const renderPeriodColumns = () => {
  if (hideAllPeriods) return []; // если скрыты все периоды, возвращаем пустой массив
  
  const periods = [];
  const startPeriod = 1;
  
  for (let i = startPeriod; i <= 12; i++) {
    periods.push(
      <th key={`P${i}`} style={{
        padding: '15px 10px',
        textAlign: 'right',
        fontWeight: 600,
        color: '#6c757d',
        fontSize: '13px',
        textTransform: 'uppercase',
        borderRight: '1px solid #e9ecef',
        borderBottom: '2px solid #dee2e6',
        position: 'sticky',
        top: 0,
        backgroundColor: '#f8f9fa'
      }}>
        P{i}
        {showWithTax && (
          <span style={{ 
            fontSize: '10px', 
            display: 'block', 
            fontWeight: 'normal',
            color: '#2c3e50',
            marginTop: '2px' 
          }}>
            After VAT
          </span>
        )}
      </th>
    );

    // Conditionally add churn column
    if (showPChurn) {
      periods.push(
        <th key={`P${i} Churn`} style={{
          padding: '15px 10px',
          textAlign: 'right',
          fontWeight: 600,
          color: '#6c757d',
          fontSize: '13px',
          textTransform: 'uppercase',
          borderRight: '1px solid #e9ecef',
          borderBottom: '2px solid #dee2e6',
          position: 'sticky',
          top: 0,
          backgroundColor: '#f8f9fa'
        }}>
          P{i} Churn
        </th>
      );
    }

    // Conditionally add count column
    if (showPCount) {
      periods.push(
        <th key={`P${i} Count`} style={{
          padding: '15px 10px',
          textAlign: 'right',
          fontWeight: 600,
          color: '#6c757d',
          fontSize: '13px',
          textTransform: 'uppercase',
          borderRight: '1px solid #e9ecef',
          borderBottom: '2px solid #dee2e6',
          position: 'sticky',
          top: 0,
          backgroundColor: '#f8f9fa'
        }}>
          P{i} Count
        </th>
      );
    }

    // Conditionally add predicted revenue column
    if (showPredictedRevenue) {
      periods.push(
        <th key={`Predicted P${i}`} style={{
          padding: '15px 10px',
          textAlign: 'right',
          fontWeight: 600,
          color: '#6c757d',
          fontSize: '13px',
          textTransform: 'uppercase',
          borderRight: '1px solid #e9ecef',
          borderBottom: '2px solid #dee2e6',
          backgroundColor: '#f0f4f8',
          position: 'sticky',
          top: 0
        }}>
          Predicted P{i}
          {showWithTax && (
            <span style={{ 
              fontSize: '10px', 
              display: 'block', 
              fontWeight: 'normal',
              color: '#2c3e50',
              marginTop: '2px' 
            }}>
              After VAT
            </span>
          )}
        </th>
      );
    }

    // NEW: Conditionally add early predicted revenue column
    if (showEarlyPredicted) {
      periods.push(
        <th key={`Early Predicted P${i}`} style={{
          padding: '15px 10px',
          textAlign: 'right',
          fontWeight: 600,
          color: '#6c757d',
          fontSize: '13px',
          textTransform: 'uppercase',
          borderRight: '1px solid #e9ecef',
          borderBottom: '2px solid #dee2e6',
          backgroundColor: '#fff3e0',
          position: 'sticky',
          top: 0
        }}>
          Early P{i}
          <span style={{ 
            fontSize: '10px', 
            display: 'block', 
            fontWeight: 'normal',
            color: '#ff6b35',
            marginTop: '2px' 
          }}>
            Early Predicted
          </span>
          {showWithTax && (
            <span style={{ 
              fontSize: '10px', 
              display: 'block', 
              fontWeight: 'normal',
              color: '#2c3e50',
              marginTop: '1px' 
            }}>
              After VAT
            </span>
          )}
        </th>
      );
    }
  }
  return periods;
};

  // Загрузка списков стран и кампаний
  // Update the fetchFilterData function to include date parameters

// Replace the existing fetchFilterData function in useEffect with this:
// Внутри компонента AndroidDashboardPage

useEffect(() => {
  const fetchFilterData = async () => {
    try {
      // --- Общие параметры (только даты) ---
      const baseParams: Record<string, any> = {};
      if (viewMode === 'daily' || viewMode === 'weekly') {
        if (useDateRange) {
          if (dateFrom) baseParams.date_from = dateFrom;
          if (dateTo) baseParams.date_to = dateTo;
        } else if (singleDate) {
          baseParams.date_from = singleDate;
          baseParams.date_to = singleDate;
        }
      } else { // monthly view
        if (useDateRange) {
          if (yearFrom) baseParams.year_from = parseInt(yearFrom);
          if (monthFrom) baseParams.month_from = parseInt(monthFrom);
          if (yearTo) baseParams.year_to = parseInt(yearTo);
          if (monthTo) baseParams.month_to = parseInt(monthTo);
        } else {
          if (singleYear) baseParams.year_from = parseInt(singleYear);
          if (singleYear) baseParams.year_to = parseInt(singleYear);
          if (singleMonth) baseParams.month_from = parseInt(singleMonth);
          if (singleMonth) baseParams.month_to = parseInt(singleMonth);
        }
      }

      // Загружаем ВСЕ страны для выбранного периода
      const countriesResponse = await axios.get(`/api/${database}/countries`, { params: baseParams });
      if (countriesResponse.data.success) {
        setCountries(countriesResponse.data.data);
      }

      // Загружаем ВСЕ кампании для выбранного периода
      const campaignsResponse = await axios.get(`/api/${database}/campaigns`, { params: baseParams });
      if (campaignsResponse.data.success) {
        setCampaigns(campaignsResponse.data.data);
      }
      
      // Платформы берутся из основного запроса данных (fetchOrdersData), поэтому здесь ничего не делаем.

    } catch (err) {
      console.error('Failed to fetch filter data:', err);
    }
  };
  
  fetchFilterData();
}, [
  // Зависимость теперь ТОЛЬКО от дат, чтобы получать полные списки
  database,
  viewMode,
  dateFrom,
  dateTo,
  singleDate,
  yearFrom,
  yearTo,
  monthFrom,
  monthTo,
  singleYear,
  singleMonth,
  useDateRange
]);

// Update the rendering logic to handle aggregated date ranges
// This code should replace part of your existing render function

const formattedDateDisplay = (date: string) => {
  // Check if date is a range (contains a " - ")
  if (date.includes(" - ")) {
    const [startDate, endDate] = date.split(" - ");
    if (viewMode === 'monthly') {
      // For monthly view, format as Month Year - Month Year
      const formatMonthYear = (dateStr: string) => {
        if (dateStr === '0000-00') return 'Unknown Date';
        const [year, month] = dateStr.split('-');
        return new Date(parseInt(year), parseInt(month) - 1)
          .toLocaleString('default', { month: 'long', year: 'numeric' });
      };
      return `${formatMonthYear(startDate)} - ${formatMonthYear(endDate)}`;
    } else if (viewMode === 'weekly') {
      // For weekly view, format special with week information
      const formatWeekDate = (dateStr: string) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        // Get week number - ISO week number (starting from Monday)
        const getWeekNumber = (d: Date) => {
          const firstDayOfYear = new Date(d.getFullYear(), 0, 1);
          const pastDaysOfYear = (d.getTime() - firstDayOfYear.getTime()) / 86400000;
          return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
        };
        const weekNum = getWeekNumber(date);
        
        return `${date.toLocaleDateString()} (Week ${weekNum})`;
      };
      
      return `${formatWeekDate(startDate)} - ${formatWeekDate(endDate)}`;
    } else {
      // For daily view, format as nicer date format
      return `${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
    }
  } else {
    // Single date handling (existing code)
    if (viewMode === 'monthly') {
      // For monthly view, format YYYY-MM as Month Year
      if (date === '0000-00') return 'Unknown Date'; 
      return new Date(parseInt(date.split('-')[0]), parseInt(date.split('-')[1]) - 1)
        .toLocaleString('default', { month: 'long', year: 'numeric' });
    } else if (viewMode === 'weekly') {
      // For weekly view, format single date with week number
      const d = new Date(date);
      const getWeekNumber = (d: Date) => {
        const firstDayOfYear = new Date(d.getFullYear(), 0, 1);
        const pastDaysOfYear = (d.getTime() - firstDayOfYear.getTime()) / 86400000;
        return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
      };
      
      return `${d.toLocaleDateString()} (Week ${getWeekNumber(d)})`;
    } else {
      // For daily view, just show the date
      return date;
    }
  }
};

  // Загрузка данных заказов с учетом фильтров
// Replace the current fetchOrdersData function with this updated version:

// Добавьте новый useEffect
useEffect(() => {
  setShowCountries(true);
  setShowCampaigns(true);
}, [
  dateFrom, 
  dateTo, 
  singleDate, 
  yearFrom, 
  yearTo, 
  monthFrom, 
  monthTo, 
  singleYear, 
  singleMonth
]); // зависимости только от дат

useEffect(() => {
  // Очищаем данные при изменении режима отображения стран
  setOrdersData({});
  // Устанавливаем загрузку, чтобы показать пользователю, что данные обновляются
  setLoading(true);
}, [showCountries]);

// ВНУТРИ AndroidDashboardPage

// --- ИЗМЕНИТЬ ЭТИ СТРОКИ ---
const [unfilteredOrdersData, setUnfilteredOrdersData] = useState<GroupedOrderData>({}); // Новое состояние для полных данных




// ==================== НОВЫЕ useEffect ДЛЯ ДАННЫХ ====================

// useEffect №1: ЗАГРУЗКА ДАННЫХ (реагирует только на даты и базовые настройки)
// useEffect №1: ЗАГРУЗКА ДАННЫХ (реагирует только на параметры API)
useEffect(() => {
  // Эта вспомогательная функция может остаться снаружи, если не использует state/props,
  // или ее тоже можно перенести внутрь.
  const getEffectiveDates = () => {
    const getTodayDate = (): string => {
      const today = new Date();
      return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    };

    if (viewMode === 'daily' || viewMode === 'weekly') {
      if (useDateRange) {
        return { dateFrom: dateFrom || getTodayDate(), dateTo: dateTo || dateFrom || getTodayDate() };
      }
      return { dateFrom: singleDate || getTodayDate(), dateTo: singleDate || getTodayDate() };
    } else {
      const startYear = useDateRange ? yearFrom : singleYear;
      const startMonth = useDateRange ? monthFrom : singleMonth;
      const endYear = useDateRange ? yearTo : singleYear;
      const endMonth = useDateRange ? monthTo : singleMonth;
      const startDate = `${startYear}-${String(startMonth).padStart(2, '0')}-01`;
      const lastDay = new Date(parseInt(endYear), parseInt(endMonth), 0).getDate();
      const endDate = `${endYear}-${String(endMonth).padStart(2, '0')}-${lastDay}`;
      return { dateFrom: startDate, dateTo: endDate };
    }
  };

  // ✅ РЕШЕНИЕ: ОПРЕДЕЛЯЕМ ФУНКЦИЮ ВНУТРИ useEffect
  const fetchOrdersData = async () => {
    setLoading(true);
    setError(null);

    const params: Record<string, any> = {
      country: showCountries,
      distribute_unknowns: distributeUnknowns,
      distribute_direct: distributeDirect, // ✅ Теперь здесь всегда будет актуальное значение
      keyevent: viewMode === 'daily' ? 'days' : viewMode === 'weekly' ? 'weeks' : 'month'
    };
    
    const { dateFrom: effectiveFrom, dateTo: effectiveTo } = getEffectiveDates();
    params.date_from = effectiveFrom;
    params.date_to = effectiveTo;
    
    console.log('Sending API request with params:', params); // Добавим лог для проверки
    
    try {
      const response = await axios.get(`/api/${database}/orders`, { params });
      
      setUnfilteredOrdersData(response.data.data as GroupedOrderData || {});

      const coefficients = calculateHistoricalCoefficients(response.data.data || {});
    setHistoricalCoefficients(coefficients);
      
      const allPlatforms = new Set<string>();
      Object.values(response.data.data || {}).forEach((dateGroup: any) => {
        Object.values(dateGroup).forEach((items: any) => {
          items.forEach((item: OrderData) => {
            if (item.platform) allPlatforms.add(item.platform);
          });
        });
      });
      setPlatforms(Array.from(allPlatforms).sort());
      
    } catch (err) {
      console.error('Failed to fetch orders data:', err);
      setError('Failed to fetch orders data');
      setUnfilteredOrdersData({}); // Очищаем данные при ошибке
    } finally {
      setLoading(false);
    }
  };

  // Вызываем свежесозданную функцию
  fetchOrdersData();

}, [
  // Все зависимости, от которых зависит `fetchOrdersData`, должны быть здесь.
  database, dateFrom, dateTo, singleDate, useDateRange, viewMode,
  yearFrom, yearTo, monthFrom, monthTo, singleYear, singleMonth,
  showCountries, distributeUnknowns, distributeDirect
]);

// useEffect №2: ФИЛЬТРАЦИЯ ДАННЫХ НА КЛИЕНТЕ
useEffect(() => {
  if (Object.keys(unfilteredOrdersData).length === 0) {
    if (!loading) setOrdersData({}); // Очищаем, только если не идет загрузка
    return;
  }

  const filteredData: GroupedOrderData = {};
  
  Object.entries(unfilteredOrdersData).forEach(([date, countries]) => {
    const newCountries: { [country: string]: OrderData[] } = {};
    
    Object.entries(countries).forEach(([countryName, items]) => {
      if (selectedCountries.length > 0 && !selectedCountries.includes(countryName)) {
        return;
      }
      
      const newItems = items.filter(item => 
        (selectedCampaigns.length === 0 || selectedCampaigns.includes(item.campaign)) &&
        (selectedPlatforms.length === 0 || selectedPlatforms.includes(item.platform || '---'))
      );
      
      if (newItems.length > 0) {
        newCountries[countryName] = newItems;
      }
    });
    
    if (Object.keys(newCountries).length > 0) {
      filteredData[date] = newCountries;
    }
  });

  setOrdersData(filteredData);

}, [unfilteredOrdersData, selectedCountries, selectedCampaigns, selectedPlatforms, loading]);

// Добавьте этот useEffect для очистки данных при изменении режима отображения
useEffect(() => {
  console.log('showCountries changed to:', showCountries);
  // Очищаем данные при изменении режима отображения стран
  setOrdersData({});
  // Устанавливаем загрузку, чтобы показать пользователю, что данные обновляются
  setLoading(true);
}, [showCountries]);

  // Обработчики для модальных окон и выбора








  const clearDateFilter = () => {
    setDateFrom('');
    setDateTo('');
    setSingleDate('');
    setYearFrom(new Date().getFullYear().toString());
    setYearTo(new Date().getFullYear().toString());
    setMonthFrom('1');
    setMonthTo('12');
    setSingleYear(new Date().getFullYear().toString());
    setSingleMonth((new Date().getMonth() + 1).toString());
  };



  const calculateARPPU = (item: OrderData): number => {
    const totalRevenue = calculateTotalRevenue(item);
    const uniquePayers = item.count_unique_payers || 0;
    return uniquePayers > 0 ? totalRevenue / uniquePayers : 0;
  };

  const calculateLTV = (item: OrderData): number => {
    const totalRevenue = calculateTotalRevenue(item);
    const activationCount = item.count_unique_payers_activation || 0;
    return activationCount > 0 ? totalRevenue / activationCount : 0;
  };

  

  const calculateCPU = (item: OrderData): number => {
    const costs = item.costs || 0;
    const uniquePayers = item.count_unique_payers || 0;
    return uniquePayers > 0 ? costs / uniquePayers : 0;
  };

  const calculateCPA = (item: OrderData): number => {
    const costs = item.costs || 0;
    const activationPurchases = item.revenue_activation_purchase_count || 0;
    return activationPurchases > 0 ? costs / activationPurchases : 0;
  };

  const calculateROI = (item: OrderData): number => {
    const totalRevenue = calculateTotalRevenue(item);
    const costs = item.costs || 0;
    
    return costs > 0 ? ((totalRevenue - costs) / costs) * 100 : 0;
  };

  const calculatePredictedROI2 = (item: OrderData): number => {
    const totalRevenue = item.total_revenue || 0;
    const costs = item.costs || 0;
    return costs > 0 ? ((totalRevenue - costs) / costs) * 100 : 0;
  };
 
  // Enhanced функция для получения информации о ячейке с полными формулами и источниками данных
  const getCellExplanation = (item: OrderData, key: string, label: string = '', periodNum?: number): string => {
    const value = item[key as keyof OrderData];
    let explanation = `${label || key}\n------------------------\n`;
    
    // Add VAT information for revenue fields when VAT is enabled
    const isRevenueField = (
      key === 'revenue_activation' || 
      key === 'total_revenue' || 
      key === 'total_predicted_revenue' ||
      key === 'total_early_predicted_revenue' ||
      (key.startsWith('revenue_p') && !key.endsWith('_count')) ||
      key.startsWith('predicted_revenue_p')
    );
    
    if (showWithTax && isRevenueField && item.country) {
      const vatRate = getVatRate(item.country);
      explanation += `VAT Rate for ${item.country}: ${(vatRate * 100).toFixed(0)}%\n`;
      explanation += `Values shown after VAT adjustment: original × (1 - ${vatRate})\n\n`;
    }
    
    // Handle churn rate cells (p1_churn, p2_churn, etc.)
    if (key.startsWith('p') && key.endsWith('_churn')) {
      const periodNum = parseInt(key.replace('p', '').replace('_churn', ''));
      const activationCount = item.revenue_activation_count || 0;
      const periodCountKey = `revenue_p${periodNum}_count` as keyof OrderData;
      const periodCount = item[periodCountKey] as number | null;
      
      explanation += `Formula: (revenue_p${periodNum}_count / revenue_activation_count) * 100\n`;
      explanation += `Data: (${periodCount || 0} / ${activationCount}) * 100 = ${calculateChurnRate(item, periodNum)}\n`;
      explanation += `Represents the percentage of users from the activation period still active in period ${periodNum}\n`;
      return explanation;
    }

    // Handle early predicted revenue explanations
    if (key === 'total_early_predicted_revenue') {
      explanation += `Formula: Early Predicted Revenue calculated from revenue_p1 using churn rates\n`;
      explanation += `Base: revenue_p1 = ${item.revenue_p1 || 0}\n`;
      explanation += `Chain: p1 → p2 (×churn_p2) → p3 (×churn_p3) → ... → p24\n`;
      
      if (showWithTax) {
        explanation += `\nNote: All revenue values are adjusted for VAT\n`;
      }
      
      explanation += `Value: ${calculateEarlyPredictedRevenue(item).toFixed(2)}\n`;
      return explanation;
    }

    if (key === 'early_predicted_ltv') {
      explanation += `Formula: Total Early Predicted Revenue / Count of Unique Payers at Activation\n`;
      const earlyPredictedRevenue = calculateEarlyPredictedRevenue(item);
      const activationCount = item.count_unique_payers_activation || 0;
      const earlyLTV = activationCount > 0 ? earlyPredictedRevenue / activationCount : 0;
      explanation += `Data: ${earlyPredictedRevenue.toFixed(2)} / ${activationCount} = ${earlyLTV.toFixed(2)}\n`;
      
      if (showWithTax) {
        explanation += `\nNote: Early Predicted Revenue is adjusted for VAT\n`;
      }
      return explanation;
    }

    if (key === 'early_predicted_roi') {
      explanation += `Formula: ((Total Early Predicted Revenue - Costs) / Costs) * 100\n`;
      const earlyPredictedRevenue = calculateEarlyPredictedRevenue(item);
      const costs = item.costs || 0;
      const earlyROI = costs > 0 ? ((earlyPredictedRevenue - costs) / costs) * 100 : 0;
      explanation += `Data: ((${earlyPredictedRevenue.toFixed(2)} - ${costs.toFixed(2)}) / ${costs.toFixed(2)}) * 100 = ${earlyROI.toFixed(2)}%\n`;
      
      if (showWithTax) {
        explanation += `\nNote: Early Predicted Revenue is adjusted for VAT\n`;
      }
      return explanation;
    }
    
    switch(key) {
      case 'arppu':
        explanation += `Formula: Total Revenue / Count of Unique Payers\n`;
        const arppuTotalRev = calculateTotalRevenue(item);
        const uniquePayers = item.count_unique_payers || 0;
        const arppuCalc = uniquePayers > 0 ? arppuTotalRev / uniquePayers : 0;
        explanation += `Data: ${arppuTotalRev.toFixed(2)} / ${uniquePayers} = ${arppuCalc.toFixed(2)}\n`;
        
        if (showWithTax) {
          explanation += `\nNote: Total Revenue is adjusted for VAT\n`;
        }
        break;

      case 'roi':
        explanation += `Formula: ((Total Revenue - Costs) / Costs) * 100\n`;
        const roiTotalRev = calculateTotalRevenue(item);
        const roiCosts = item.costs || 0;
        const roiCalc = roiCosts > 0 ? ((roiTotalRev - roiCosts) / roiCosts) * 100 : 0;
        explanation += `Data: ((${roiTotalRev.toFixed(2)} - ${roiCosts.toFixed(2)}) / ${roiCosts.toFixed(2)}) * 100 = ${roiCalc.toFixed(2)}%\n`;
        break;
          
      case 'predicted_roi':
        explanation += `Formula: ((Revenue Activation + Sum of Predicted Revenues P1-P12 - Costs) / Costs) * 100\n`;
        
        let predRevenue2 = getAdjustedRevenue(item.revenue_activation || 0, item.country);
        let revenueParts2 = `${predRevenue2.toFixed(2)}`;
        
        for (let i = 1; i <= 12; i++) {
          const periodKey = `predicted_revenue_p${i}` as keyof OrderData;
          const periodValue = item[periodKey];
          
          if (typeof periodValue === 'number') {
            const adjustedValue = getAdjustedRevenue(periodValue, item.country);
            predRevenue2 += adjustedValue;
            revenueParts2 += ` + ${adjustedValue.toFixed(2)}`;
          }
        }
        
        const predCosts = item.costs || 0;
        const predROICalc = predCosts > 0 ? ((predRevenue2 - predCosts) / predCosts) * 100 : 0;
        
        explanation += `Detail Breakdown:\n`;
        explanation += `- Base Revenue: ${getAdjustedRevenue(item.revenue_activation || 0, item.country).toFixed(2)}\n`;
        break;
        
      case 'costs':
        explanation += `Direct value from database: ${value !== null ? (typeof value === 'number' ? value.toFixed(2) : value) : 'Not available'}\n`;
        break;
        
      case 'sum_activation_purchases':
        const sum = (item.revenue_activation_count || 0) + (item.revenue_activation_purchase_count || 0);
        explanation += `Formula: revenue_activation_count + revenue_activation_purchase_count\n`;
        explanation += `Data: ${item.revenue_activation_count || 0} + ${item.revenue_activation_purchase_count || 0} = ${sum}\n`;
        break;
        
      case 'total_revenue':
        explanation += `Formula: Revenue Activation + sum of all revenue periods (P1-P12)\n`;
        const total = calculateTotalRevenue(item);
        
        let breakdown = `${getAdjustedRevenue(item.revenue_activation || 0, item.country).toFixed(2)}`;
        for (let i = 1; i <= 12; i++) {
          const periodKey = `revenue_p${i}` as keyof OrderData;
          const periodValue = item[periodKey] as number | null;
          const adjustedValue = periodValue !== null ? 
            getAdjustedRevenue(periodValue, item.country) : 0;
          breakdown += ` + ${adjustedValue.toFixed(2)}`;
        }
        explanation += `Data: ${breakdown} = ${total.toFixed(2)}\n`;
        
        if (showWithTax) {
          const vatRate = getVatRate(item.country);
          explanation += `\nNote: All revenue values are adjusted for VAT (${vatRate * 100}%)\n`;
        }
        break;

      case 'total_predicted_revenue':
        explanation += `Formula: Revenue Activation + Revenue Activation Purchase + sum of all predicted revenue periods (P1-P24)\n`;
        const totalPredicted = calculateTotalPredictedRevenue(item);
        
        let predBreakdown = `${getAdjustedRevenue(item.revenue_activation || 0, item.country).toFixed(2)}`;
        if (item.revenue_activation_purchase_count) {
          predBreakdown += ` + ${getAdjustedRevenue(item.revenue_activation_purchase_count, item.country).toFixed(2)}`;
        }
        
        for (let i = 1; i <= 24; i++) {
          const predKey = `predicted_revenue_p${i}` as keyof OrderData;
          const predValue = item[predKey];
          
          if (predValue !== null && predValue !== undefined) {
            const adjustedPredValue = getAdjustedRevenue(predValue as number, item.country);
            predBreakdown += ` + ${adjustedPredValue.toFixed(2)}`;
          }
        }
        
        explanation += `Data: ${predBreakdown} = ${totalPredicted.toFixed(2)}\n`;
        
        if (showWithTax) {
          const vatRate = getVatRate(item.country);
          explanation += `\nNote: All revenue values are adjusted for VAT (${vatRate * 100}%)\n`;
        }
        break;
        
      case 'revenue_activation_count':
        explanation += `Number of users who activated the app\n`;
        explanation += `Value: ${value !== null ? value : 'Not available'}\n`;
        break;
        
      case 'revenue_activation_purchase_count':
        explanation += `Number of purchases made during activation\n`;
        explanation += `Value: ${value !== null ? value : 'Not available'}\n`;
        break;
        
      case 'revenue_activation':
        explanation += `Revenue from initial user activations\n`;
        
        if (showWithTax && item.country) {
          const vatRate = getVatRate(item.country);
          const originalValue = value !== null ? (typeof value === 'number' ? value : 0) : 0;
          const adjustedValue = getAdjustedRevenue(originalValue, item.country);
          
          explanation += `Original Value: ${originalValue.toFixed(2)}\n`;
          explanation += `VAT Rate: ${(vatRate * 100).toFixed(0)}%\n`;
          explanation += `Adjusted Value: ${originalValue.toFixed(2)} × (1 - ${vatRate}) = ${adjustedValue.toFixed(2)}\n`;
        } else {
          explanation += `Value: ${value !== null ? (typeof value === 'number' ? value.toFixed(2) : value) : 'Not available'}\n`;
        }
        break;
        
      case 'cpa_cost_per_action':
        explanation += `Formula: Costs / Revenue Activation Purchase Count\n`;
        const cpaCosts = item.costs || 0;
        const activationPurchases = item.revenue_activation_purchase_count || 0;
        const cpaCalc = activationPurchases > 0 ? cpaCosts / activationPurchases : 0;
        explanation += `Data: ${cpaCosts.toFixed(2)} / ${activationPurchases} = ${cpaCalc.toFixed(2)}\n`;
        break;
        
        case 'cpu_cost_per_user':
          explanation += `Formula: Costs / Count of Unique Payers\n`;
          const cpuCosts = item.costs || 0;
          const cpuPayers = item.count_unique_payers || 0;
          const cpuCalc = cpuPayers > 0 ? cpuCosts / cpuPayers : 0;
          explanation += `Data: ${cpuCosts.toFixed(2)} / ${cpuPayers} = ${cpuCalc.toFixed(2)}\n`;
          break;
          
        case 'arppu':
          explanation += `Formula: Total Revenue / Count of Unique Payers\n`;
          const totalRev = calculateTotalRevenue(item);
          const uniquePayers2 = item.count_unique_payers || 0;
          const arppuCalc2 = uniquePayers2 > 0 ? totalRev / uniquePayers2 : 0;
          explanation += `Data: ${totalRev.toFixed(2)} / ${uniquePayers2} = ${arppuCalc2.toFixed(2)}\n`;
          
          if (showWithTax) {
            explanation += `\nNote: Total Revenue is adjusted for VAT\n`;
          }
          break;
          
        case 'ltv':
          explanation += `Formula: Total Revenue / Count of Unique Payers at Activation\n`;
          const ltvTotalRev = calculateTotalRevenue(item);
          const activationCount = item.count_unique_payers_activation || 0;
          const ltvCalc = activationCount > 0 ? ltvTotalRev / activationCount : 0;
          explanation += `Data: ${ltvTotalRev.toFixed(2)} / ${activationCount} = ${ltvCalc.toFixed(2)}\n`;
          
          if (showWithTax) {
            explanation += `\nNote: Total Revenue is adjusted for VAT\n`;
          }
          break;
          
        case 'predicted_ltv':
          explanation += `Formula: (Revenue Activation + Sum of Predicted Revenues P1-P12) / Count of Unique Payers at Activation\n`;
          const predictedRevenue = calculatePredictedRevenue2(item);
          const predActivationCount = item.count_unique_payers_activation || 0;
          const predictedLTVCalc = predActivationCount > 0 ? predictedRevenue / predActivationCount : 0;
          
          let revenueParts = `${getAdjustedRevenue(item.revenue_activation || 0, item.country).toFixed(2)}`;
          for (let i = 1; i <= 12; i++) {
            const periodKey = `predicted_revenue_p${i}` as keyof OrderData;
            const periodValue = item[periodKey];
            if (periodValue !== null && periodValue !== undefined) {
              const adjustedValue = getAdjustedRevenue(periodValue as number, item.country);
              revenueParts += ` + ${adjustedValue.toFixed(2)}`;
            }
          }
          
          explanation += `Data: (${revenueParts}) / ${predActivationCount} = ${predictedLTVCalc.toFixed(2)}\n`;
          
          if (showWithTax) {
            explanation += `\nNote: All revenue values are adjusted for VAT\n`;
          }
          break;
          
        case 'country':
          explanation += `Country code for user region\n`;
          explanation += `Value: ${value}\n`;
          if (showWithTax) {
            const vatRate = getVatRate(item.country);
            explanation += `VAT Rate: ${(vatRate * 100).toFixed(0)}%\n`;
          }
          break;
          
        case 'campaign':
          explanation += `Marketing campaign identifier\n`;
          explanation += `Value: ${value}\n`;
          break;
          
        default:
          // Handle revenue_p* (period revenues)
          if (key.startsWith('revenue_p') && !key.endsWith('_count')) {
            const periodNum = key.replace('revenue_p', '');
            explanation += `Revenue for period ${periodNum}\n`;
            
            if (showWithTax && item.country) {
              const vatRate = getVatRate(item.country);
              const originalValue = value !== null ? (typeof value === 'number' ? value : 0) : 0;
              const adjustedValue = getAdjustedRevenue(originalValue, item.country);
              
              explanation += `Original Value: ${originalValue.toFixed(2)}\n`;
              explanation += `VAT Rate: ${(vatRate * 100).toFixed(0)}%\n`;
              explanation += `Adjusted Value: ${originalValue.toFixed(2)} × (1 - ${vatRate}) = ${adjustedValue.toFixed(2)}\n`;
            } else {
              explanation += `Value: ${value !== null ? (typeof value === 'number' ? value.toFixed(2) : value) : 'Not available'}\n`;
            }
          } 
          // Handle revenue_p*_count items
          else if (key.startsWith('revenue_p') && key.endsWith('_count')) {
            const periodNum = key.replace('revenue_p', '').replace('_count', '');
            explanation += `Count of users for period ${periodNum}\n`;
            explanation += `Value: ${value !== null ? value : 'Not available'}\n`;
          }
          // Handle predicted_revenue_p* items
          else if (key.startsWith('predicted_revenue_p')) {
            if (periodNum && periodNum > 1) {
              explanation += `Formula: Previous period predicted revenue * predicted churn rate\n`;
              
              const prevPredictedKey = `predicted_revenue_p${periodNum-1}` as keyof OrderData;
              const churnKey = `predicted_churn_p${periodNum}` as keyof OrderData;
              
              const prevPredicted = periodNum === 2 ? item.revenue_p1 : item[prevPredictedKey];
              const churn = item[churnKey];
              
              if (showWithTax && item.country) {
                const vatRate = getVatRate(item.country);
                const origPrevPredicted = prevPredicted !== null ? Number(prevPredicted).toFixed(2) : '0.00';
                const adjustedPrevPredicted = prevPredicted !== null ? 
                  getAdjustedRevenue(prevPredicted as number, item.country).toFixed(2) : '0.00';
                
                explanation += `Data (after VAT adjustment): ${adjustedPrevPredicted} * ${churn !== null ? Number(churn).toFixed(4) : 'N/A'}\n`;
                explanation += `Original Value: ${origPrevPredicted}\n`;
                explanation += `VAT Rate: ${(vatRate * 100).toFixed(0)}%\n`;
              } else {
                explanation += `Data: ${prevPredicted !== null ? Number(prevPredicted).toFixed(2) : '0.00'} * ${churn !== null ? Number(churn).toFixed(4) : 'N/A'}\n`;
              }
            } else if (periodNum === 1) {
              explanation += `For P1, predicted revenue equals actual P1 revenue\n`;
              
              if (showWithTax && item.country) {
                const vatRate = getVatRate(item.country);
                const originalValue = item.revenue_p1 !== null ? Number(item.revenue_p1) : 0;
                const adjustedValue = getAdjustedRevenue(originalValue, item.country);
                
                explanation += `Original Value: ${originalValue.toFixed(2)}\n`;
                explanation += `VAT Rate: ${(vatRate * 100).toFixed(0)}%\n`;
                explanation += `Adjusted Value: ${originalValue.toFixed(2)} × (1 - ${vatRate}) = ${adjustedValue.toFixed(2)}\n`;
              } else {
                explanation += `Value: ${item.revenue_p1 !== null ? Number(item.revenue_p1).toFixed(2) : '0.00'}\n`;
              }
            } else {
              explanation += `Predicted revenue for a future period\n`;
              
              if (showWithTax && item.country && value !== null && typeof value === 'number') {
                const vatRate = getVatRate(item.country);
                const adjustedValue = getAdjustedRevenue(value, item.country);
                
                explanation += `Original Value: ${value.toFixed(2)}\n`;
                explanation += `VAT Rate: ${(vatRate * 100).toFixed(0)}%\n`;
                explanation += `Adjusted Value: ${value.toFixed(2)} × (1 - ${vatRate}) = ${adjustedValue.toFixed(2)}\n`;
              } else {
                explanation += `Value: ${value !== null ? (typeof value === 'number' ? value.toFixed(2) : value) : 'Not available'}\n`;
              }
            }
          }
          else if (key.startsWith('predicted_churn_p')) {
            const periodNum = key.replace('predicted_churn_p', '');
            explanation += `Predicted churn rate for period ${periodNum}\n`;
            explanation += `Value: ${value !== null ? (typeof value === 'number' ? value.toFixed(4) : value) : 'Not available'}\n`;
          }
          // Handle profit field
          else if (key === 'profit') {
            explanation += `Formula: Total Revenue - Costs\n`;
            const totalRev = calculateTotalRevenue(item);
            const costs = item.costs || 0;
            const profit = totalRev - costs;
            
            explanation += `Data: ${totalRev.toFixed(2)} - ${costs.toFixed(2)} = ${profit.toFixed(2)}\n`;
            
            if (showWithTax) {
              explanation += `\nNote: Total Revenue is adjusted for VAT\n`;
            }
          }
          // Fallback for any other fields
          else {
            explanation += `Value: ${value !== null ? (typeof value === 'number' ? value.toFixed(2) : value) : 'Not available'}\n`;
          }
      }
      
      return explanation;
    };
  
    // Обработчик наведения на ячейку
    const handleCellHover = (event: React.MouseEvent, item: OrderData, key: string, label: string = '', periodNum?: number) => {
      if (isExplanationEnabled) {
        const rect = event.currentTarget.getBoundingClientRect();
        setHoverInfo({
          x: rect.left,
          y: rect.top - 10, // Показываем немного выше ячейки
          content: getCellExplanation(item, key, label, periodNum)
        });
      }
    };
  
    // Обработчик ухода курсора с ячейки
    const handleCellLeave = () => {
      setHoverInfo(null);
    };
  
    // Лоадер
    const Loader: React.FC = () => (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '200px'
      }}>
        <Loader2 
          size={48} 
          style={{ 
            animation: 'spin 1s linear infinite',
            color: '#3498db'
          }} 
        />
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          
          .filters-animation {
            animation: slideDown 0.3s ease forwards;
          }
  
          .modal-overlay {
            animation: fadeIn 0.2s ease-out;
          }
          
          .modal-content {
            animation: slideDown 0.3s ease-out;
          }
        `}</style>
      </div>
    );
  
    // Компонент отображения выбранных фильтров
    const FilterBadge: React.FC<{ 
      label: string, 
      onClear: () => void 
    }> = ({ 
      label, 
      onClear 
    }) => (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#e9ecef',
        borderRadius: '16px',
        padding: '4px 10px',
        margin: '0 5px 5px 0',
        fontSize: '13px'
      }}>
        <span style={{ marginRight: '5px' }}>{label}</span>
        <button
          onClick={onClear}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            padding: '0',
            color: '#6c757d'
          }}
        >
          <X size={14} />
        </button>
      </div>
    );


// ==================== НОВЫЙ КОМПОНЕНТ ДЛЯ ЭЛЕМЕНТА СПИСКА ====================

// Определяем свойства (props) для нашего компонента
// ==================== НОВЫЕ КОМПОНЕНТЫ ДЛЯ МАКСИМАЛЬНОЙ ОПТИМИЗАЦИИ ====================

// Компонент №1: Отдельный элемент списка, обернутый в React.memo
const MemoizedListItem: React.FC<{
  name: string;
  isSelected: boolean;
  onItemClick: (name: string) => void;
}> = React.memo(({ name, isSelected, onItemClick }) => {
  return (
    <div 
      onClick={() => onItemClick(name)}
      style={{
        display: 'flex', alignItems: 'center', padding: '10px 0',
        cursor: 'pointer', borderBottom: '1px solid #f0f0f0',
        backgroundColor: isSelected ? '#e9f7fe' : 'transparent',
      }}
    >
      <div style={{ 
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: '24px', height: '24px', border: '1px solid #dee2e6',
        borderRadius: '4px', marginRight: '10px',
        backgroundColor: isSelected ? '#3498db' : 'transparent',
      }}>
        {isSelected && <Check size={16} color="white" />}
      </div>
      <span>{name}</span>
    </div>
  );
});

// Компонент №2: Весь прокручиваемый список, также обернутый в React.memo
const MemoizedCountryList: React.FC<{
  countries: string[];
  selectedCountries: string[];
  onItemClick: (name: string) => void;
}> = React.memo(({ countries, selectedCountries, onItemClick }) => {
  return (
    <>
      {countries.map(country => (
        <MemoizedListItem
          key={country}
          name={country}
          isSelected={selectedCountries.includes(country)}
          onItemClick={onItemClick}
        />
      ))}
    </>
  );
});
    
  
// ==================== CountryModal с кнопкой Clear All ====================
interface CountryModalProps {
  isOpen: boolean;
  onClose: () => void;
  allCountries: string[];
  allData: GroupedOrderData;
  initialSelection: string[];
  selectedCampaigns: string[];
  selectedPlatforms: string[];
  onApply: (selection: string[]) => void;
}

const CountryModal: React.FC<CountryModalProps> = ({
  isOpen, onClose, allCountries, allData, initialSelection, 
  selectedCampaigns, selectedPlatforms, onApply
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);
  const [localSelection, setLocalSelection] = useState<string[]>(initialSelection);
  const [localSearch, setLocalSearch] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLocalSelection(initialSelection);
      setLocalSearch('');
      setTimeout(() => searchInputRef.current?.focus(), 50);
    }
  }, [isOpen, initialSelection]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const addCountry = (country: string) => setLocalSelection(prev => [...prev, country].sort());
  const removeCountry = (countryToRemove: string) => setLocalSelection(prev => prev.filter(c => c !== countryToRemove));
  
  // НОВАЯ ФУНКЦИЯ: Очистить все выбранные страны
  const clearAllCountries = () => setLocalSelection([]);

  const availableCountries = React.useMemo(() => {
    return allCountries
      .filter(c => !localSelection.includes(c) && c.toLowerCase().includes(localSearch.toLowerCase()))
      .sort();
  }, [allCountries, localSelection, localSearch]);
  
  const handleToggleAll = () => {
    setLocalSelection(prev => Array.from(new Set([...prev, ...availableCountries])).sort());
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div ref={modalRef} className="modal-content" style={{ backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '800px', height: '80vh', padding: '20px', boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexShrink: 0 }}>
          <h3 style={{ margin: 0, color: '#2c3e50' }}>Select Countries</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6c757d' }}><X size={20} /></button>
        </div>
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden', gap: '20px' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <div style={{ position: 'relative', marginBottom: '15px', flexShrink: 0 }}>
              <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d' }} size={16} />
              <input ref={searchInputRef} type="text" style={{ padding: '10px 10px 10px 36px', border: '1px solid #dee2e6', borderRadius: '6px', width: '100%', fontSize: '14px' }} placeholder="Search available countries..." value={localSearch} onChange={(e) => setLocalSearch(e.target.value)} />
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #e9ecef', cursor: 'pointer' }} onClick={handleToggleAll}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', border: '1px solid #dee2e6', borderRadius: '4px', marginRight: '10px' }} />
                <span style={{ fontWeight: 500 }}>Select All Visible</span>
              </div>
              {availableCountries.length > 0 ? (
                availableCountries.map(c => <div key={c} onClick={() => addCountry(c)} style={{ display: 'flex', alignItems: 'center', padding: '10px 0', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', border: '1px solid #dee2e6', borderRadius: '4px', marginRight: '10px' }} /><span>{c}</span></div>)
              ) : (
                <div style={{ padding: '15px 0', textAlign: 'center', color: '#6c757d' }}>No available countries</div>
              )}
            </div>
          </div>
          <div style={{ width: '300px', border: '1px solid #dee2e6', borderRadius: '8px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px', borderBottom: '1px solid #dee2e6', flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h5 style={{ margin: 0, color: '#495057' }}>Selected ({localSelection.length})</h5>
              {/* НОВАЯ КНОПКА Clear All */}
              {localSelection.length > 0 && (
                <button 
                  onClick={clearAllCountries}
                  style={{
                    padding: '4px 8px',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    color: '#dc3545',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 500,
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#dc3545';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#fff';
                    e.currentTarget.style.color = '#dc3545';
                  }}
                >
                  Clear All
                </button>
              )}
            </div>
            <div style={{ overflowY: 'auto', flex: 1, padding: '4px' }}>
              {localSelection.length > 0 ? (
                localSelection.map(c => <FilterChip key={`chip-${c}`} label={c} onRemove={removeCountry} />)
              ) : (
                <div style={{ padding: '15px', textAlign: 'center', color: '#adb5bd', fontSize: '14px' }}>Click on a country to add it here.</div>
              )}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', borderTop: '1px solid #e9ecef', paddingTop: '15px', marginTop: '15px', flexShrink: 0 }}>
          <button onClick={onClose} style={{ padding: '8px 16px', border: '1px solid #dee2e6', borderRadius: '6px', backgroundColor: '#f8f9fa', cursor: 'pointer', color: '#495057' }}>Cancel</button>
          <button onClick={() => onApply(localSelection)} style={{ padding: '8px 16px', border: 'none', borderRadius: '6px', backgroundColor: '#3498db', cursor: 'pointer', color: 'white', fontWeight: 500 }}>Apply</button>
        </div>
      </div>
    </div>
  );
};
  

// ==================== CampaignModal с кнопкой Clear All ====================
interface CampaignModalProps {
  isOpen: boolean;
  onClose: () => void;
  allCampaigns: string[];
  allData: GroupedOrderData;
  initialSelection: string[];
  selectedCountries: string[];
  selectedPlatforms: string[];
  onApply: (selection: string[]) => void;
}

const CampaignModal: React.FC<CampaignModalProps> = ({
  isOpen, onClose, allCampaigns, allData, initialSelection,
  selectedCountries, selectedPlatforms, onApply
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const modalRef = useRef<HTMLDivElement>(null);
  const [localSelection, setLocalSelection] = useState<string[]>(initialSelection);
  const [localSearch, setLocalSearch] = useState('');

  useEffect(() => {
    if (isOpen) {
      setLocalSelection(initialSelection);
      setLocalSearch('');
      setTimeout(() => searchInputRef.current?.focus(), 50);
    }
  }, [isOpen, initialSelection]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const addCampaign = (campaign: string) => setLocalSelection(prev => [...prev, campaign].sort());
  const removeCampaign = (campaignToRemove: string) => setLocalSelection(prev => prev.filter(c => c !== campaignToRemove));
  
  // НОВАЯ ФУНКЦИЯ: Очистить все выбранные кампании
  const clearAllCampaigns = () => setLocalSelection([]);

  const availableCampaigns = React.useMemo(() => {
    const relevantCampaigns = new Set<string>();

    if (selectedCountries.length === 0 && selectedPlatforms.length === 0) {
      allCampaigns.forEach(campaign => relevantCampaigns.add(campaign));
    } else {
      Object.values(allData).forEach(countriesByDate => {
        Object.entries(countriesByDate).forEach(([countryName, items]) => {
          if (selectedCountries.length > 0 && !selectedCountries.includes(countryName)) {
            return;
          }
          items.forEach(item => {
            if (item.campaign && (selectedPlatforms.length === 0 || selectedPlatforms.includes(item.platform || '---'))) {
              relevantCampaigns.add(item.campaign);
            }
          });
        });
      });
    }

    return Array.from(relevantCampaigns)
      .filter(c => !localSelection.includes(c) && c.toLowerCase().includes(localSearch.toLowerCase()))
      .sort();
  }, [allCampaigns, allData, localSelection, selectedCountries, selectedPlatforms, localSearch]);

  const handleToggleAll = () => {
    setLocalSelection(prev => Array.from(new Set([...prev, ...availableCampaigns])).sort());
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div ref={modalRef} className="modal-content" style={{ backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '800px', height: '80vh', padding: '20px', boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexShrink: 0 }}>
          <h3 style={{ margin: 0, color: '#2c3e50' }}>Select Campaigns</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6c757d' }}><X size={20} /></button>
        </div>
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden', gap: '20px' }}>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <div style={{ position: 'relative', marginBottom: '15px', flexShrink: 0 }}>
              <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6c757d' }} size={16} />
              <input ref={searchInputRef} type="text" style={{ padding: '10px 10px 10px 36px', border: '1px solid #dee2e6', borderRadius: '6px', width: '100%', fontSize: '14px' }} placeholder="Search available campaigns..." value={localSearch} onChange={(e) => setLocalSearch(e.target.value)} />
            </div>
            <div style={{ overflowY: 'auto', flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #e9ecef', cursor: 'pointer' }} onClick={handleToggleAll}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', border: '1px solid #dee2e6', borderRadius: '4px', marginRight: '10px' }} />
                <span style={{ fontWeight: 500 }}>Select All Visible</span>
              </div>
              {availableCampaigns.length > 0 ? (
                availableCampaigns.map(c => <div key={c} onClick={() => addCampaign(c)} style={{ display: 'flex', alignItems: 'center', padding: '10px 0', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}><div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px', border: '1px solid #dee2e6', borderRadius: '4px', marginRight: '10px' }} /><span>{c}</span></div>)
              ) : (
                <div style={{ padding: '15px 0', textAlign: 'center', color: '#6c757d' }}>No available campaigns</div>
              )}
            </div>
          </div>
          <div style={{ width: '300px', border: '1px solid #dee2e6', borderRadius: '8px', display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px', borderBottom: '1px solid #dee2e6', flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h5 style={{ margin: 0, color: '#495057' }}>Selected ({localSelection.length})</h5>
              {/* НОВАЯ КНОПКА Clear All */}
              {localSelection.length > 0 && (
                <button 
                  onClick={clearAllCampaigns}
                  style={{
                    padding: '4px 8px',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    color: '#dc3545',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 500,
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#dc3545';
                    e.currentTarget.style.color = '#fff';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#fff';
                    e.currentTarget.style.color = '#dc3545';
                  }}
                >
                  Clear All
                </button>
              )}
            </div>
            <div style={{ overflowY: 'auto', flex: 1, padding: '4px' }}>
              {localSelection.length > 0 ? (
                localSelection.map(c => <FilterChip key={`chip-${c}`} label={c} onRemove={removeCampaign} />)
              ) : (
                <div style={{ padding: '15px', textAlign: 'center', color: '#adb5bd', fontSize: '14px' }}>Click on a campaign to add it here.</div>
              )}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', borderTop: '1px solid #e9ecef', paddingTop: '15px', marginTop: '15px', flexShrink: 0 }}>
          <button onClick={onClose} style={{ padding: '8px 16px', border: '1px solid #dee2e6', borderRadius: '6px', backgroundColor: '#f8f9fa', cursor: 'pointer', color: '#495057' }}>Cancel</button>
          <button onClick={() => onApply(localSelection)} style={{ padding: '8px 16px', border: 'none', borderRadius: '6px', backgroundColor: '#3498db', cursor: 'pointer', color: 'white', fontWeight: 500 }}>Apply</button>
        </div>
      </div>
    </div>
  );
};

  
  
  // Расширенные фильтры с анимацией
  const Filters: React.FC = () => {
    return (
      <div 
        ref={filtersRef} 
        className="filters-animation"
        style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          margin: '20px 30px',
          padding: '15px 20px',
          boxShadow: '0 4px 10px rgba(0,0,0,0.06)'
        }}
      >
       
  
        {/* Базовые переключатели отображения */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '15px',
          paddingBottom: '15px',
          borderBottom: '1px solid #e9ecef'
        }}>
          <div style={{
            display: 'flex',
            gap: '15px',
            alignItems: 'center'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <span style={{ color: '#2c3e50' }}>Show Countries</span>
              <DateRangeModal />
              <button 
              
                onClick={() => setShowCountries(!showCountries)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {showCountries ? <CheckIcon /> : <CrossIcon />}
              </button>
            </div>

           
<span style={{ color: 'lightgray' }}>|</span>
<div style={{
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
}}>

<span style={{ color: '#2c3e50' }}>Distribute Unknowns</span>
  <button 
    onClick={() => setDistributeUnknowns(!distributeUnknowns)}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
      display: 'flex',
      alignItems: 'center'
    }}
    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
  >
    {distributeUnknowns ? <CheckIcon /> : <CrossIcon />}
  </button>
</div>

<span style={{ color: 'lightgray' }}>|</span>
<div style={{
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
}}>
  <span style={{ color: '#2c3e50' }}>Distribute Direct</span>
  <button 
    onClick={() => setDistributeDirect(!distributeDirect)}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
      display: 'flex',
      alignItems: 'center'
    }}
    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
  >
    {distributeDirect ? <CheckIcon /> : <CrossIcon />}
  </button>


<span style={{ color: 'lightgray' }}>|</span>

</div>
            
            {/* NEW: Tax toggle button */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              position: 'relative',
              backgroundColor: showWithTax ? '#e3f7df' : 'transparent',  // Light green background when enabled
              padding: '5px 8px',
              borderRadius: '5px'
            }}>
              <span style={{ 
                color: '#2c3e50', 
                fontWeight: showWithTax ? 600 : 'normal'  // Bold when enabled
              }}>Show VAT</span>
              <button 
                onClick={() => setShowWithTax(!showWithTax)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {showWithTax ? <CheckIcon /> : <CrossIcon />}
              </button>
            </div>
            <span style={{ color: 'lightgray' }}>|</span>
            
            {/* NEW: Early Predicted toggle button */}
            <div style={{
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  position: 'relative',
  backgroundColor: showEarlyPredicted ? '#e3f7df' : 'transparent', // это остается как есть
  padding: '5px 8px',
  borderRadius: '5px'
}}>
              <span style={{ 
                color: '#2c3e50', 
                fontWeight: showEarlyPredicted ? 600 : 'normal'
              }}>Show Early Predicted</span>
              <button 
                onClick={() => setShowEarlyPredicted(!showEarlyPredicted)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {showEarlyPredicted ? <CheckIcon /> : <CrossIcon />}
              </button>
            </div>
            <span style={{ color: 'lightgray' }}>|</span>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <span style={{ color: '#2c3e50' }}>Show Campaigns</span>
              <button 
                onClick={() => setShowCampaigns(!showCampaigns)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {showCampaigns ? <CheckIcon /> : <CrossIcon />}
              </button>
            </div>
  
            <span style={{ color: 'lightgray' }}>|</span>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <span style={{ color: '#2c3e50' }}>Show Predicted Revenue</span>
              <button 
                onClick={() => setShowPredictedRevenue(!showPredictedRevenue)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {showPredictedRevenue ? <CheckIcon /> : <CrossIcon />}
              </button>
            </div>
            
            <span style={{ color: 'lightgray' }}>|</span>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <span style={{ color: '#2c3e50' }}>Show P Count</span>
              <button 
                onClick={() => setShowPCount(!showPCount)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {showPCount ? <CheckIcon /> : <CrossIcon />}
              </button>
            </div>            
  
  
            <span style={{ color: 'lightgray' }}>|</span>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <span style={{ color: '#2c3e50' }}>Show P* Churn</span>
              <button 
                onClick={() => setShowPChurn(!showPChurn)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease',
                  display: 'flex',
                  alignItems: 'center'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                {showPChurn ? <CheckIcon /> : <CrossIcon />}
              </button>
            </div>
  
            <span style={{ color: 'lightgray' }}>|</span>
          
          
<div style={{
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
}}>
  <span style={{ color: '#2c3e50' }}>Hide All P*</span>
  <button 
    onClick={() => setHideAllPeriods(!hideAllPeriods)}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
      display: 'flex',
      alignItems: 'center'
    }}
    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
  >
    {hideAllPeriods ? <CheckIcon /> : <CrossIcon />}
  </button>
</div>

            <span style={{ color: 'lightgray' }}>|</span>

<div style={{
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
}}>
  <span style={{ color: '#2c3e50' }}>Show Platform</span>
  <button 
    onClick={() => setShowPlatform(!showPlatform)}
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
      display: 'flex',
      alignItems: 'center'
    }}
    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
  >
    {showPlatform ? <CheckIcon /> : <CrossIcon />}
  </button>
</div>

  
          </div>
        </div>
        
        {/* Расширенные фильтры */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column'
        }}>
          <div style={{ 
            display: 'flex',
            flexWrap: 'wrap',
            gap: '15px',
            marginBottom: '15px'
          }}>
            {/* Кнопка для открытия модального окна выбора стран */}
            <div style={{ minWidth: '220px' }}>
              <button 
                onClick={() => setIsCountryModalOpen(true)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 12px',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  backgroundColor: '#fff',
                  width: '100%',
                  textAlign: 'left',
                  fontSize: '14px'
                }}
              >
                <span>{selectedCountries.length ? `${selectedCountries.length} countries selected` : 'Select countries'}</span>
                <ChevronDown size={16} />
              </button>
            </div>
            
            {/* Кнопка для открытия модального окна выбора кампаний */}
            <div style={{ minWidth: '220px' }}>
              <button 
                onClick={() => setIsCampaignModalOpen(true)}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '8px 12px',
                  border: '1px solid #dee2e6',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  backgroundColor: '#fff',
                  width: '100%',
                  textAlign: 'left',
                  fontSize: '14px'
                }}
              >
                <span>{selectedCampaigns.length ? `${selectedCampaigns.length} campaigns selected` : 'Select campaigns'}</span>
                <ChevronDown size={16} />
              </button>
            </div>

             <div style={{ minWidth: '220px' }}>
    <button 
      onClick={() => setIsPlatformModalOpen(true)}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 12px',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        cursor: 'pointer',
        backgroundColor: '#fff',
        width: '100%',
        textAlign: 'left',
        fontSize: '14px'
      }}
    >
      <span>{selectedPlatforms.length ? `${selectedPlatforms.length} platforms selected` : 'Select platforms'}</span>
      <ChevronDown size={16} />
    </button>


    
  </div>

  <div style={{ minWidth: '220px' }}>
    

  <button style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 12px',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        cursor: 'pointer',
        backgroundColor: '#fff',
        width: '100%',
        textAlign: 'left',
        fontSize: '14px'
      }} onClick={handleClearCountry}>
    Clear Country
  </button>


    
  </div>

  <div style={{ minWidth: '220px' }}>
   

  <button style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 12px',
        border: '1px solid #dee2e6',
        borderRadius: '6px',
        cursor: 'pointer',
        backgroundColor: '#fff',
        width: '100%',
        textAlign: 'left',
        fontSize: '14px'
      }} onClick={handleClearCampaign}>
    Clear Campaign
  </button>
    
  </div>
  
            {/* Выбор диапазона дат */}
            <DateRangeSelector 
    onApply={(startDate, endDate, viewMode) => {
      // Always set date range mode
      setUseDateRange(true);
      
      // Convert view mode
      if (viewMode === 'day') {
        setViewMode('daily');
      } else if (viewMode === 'week') {
        setViewMode('weekly');
      } else {
        setViewMode('monthly');
      }
      
      // For day and week view, use the same approach with dateFrom and dateTo
      if (viewMode === 'day' || viewMode === 'week') {
        // For day and week view, set full date range
        setDateFrom(startDate);
        setDateTo(endDate || startDate);
        setSingleDate(startDate);
        
        // Reset month-specific filters
        setYearFrom('');
        setYearTo('');
        setMonthFrom('');
        setMonthTo('');
        setSingleYear('');
        setSingleMonth('');
      } else {
        // For month view, parse and set month range
        const [startYear, startMonth] = startDate.split('-').map(Number);
        const [endYear, endMonth] = (endDate || startDate).split('-').map(Number);
        
        setYearFrom(startYear.toString());
        setMonthFrom(startMonth.toString());
        setYearTo(endYear.toString());
        setMonthTo(endMonth.toString());
        
        // Reset day-specific filters
        setDateFrom('');
        setDateTo('');
        setSingleDate('');
        setSingleYear(startYear.toString());
        setSingleMonth(startMonth.toString());
      }
    }}
    initialStartDate={viewMode === 'daily' || viewMode === 'weekly'
      ? (useDateRange ? dateFrom : singleDate) 
      : (useDateRange 
          ? `${yearFrom}-${monthFrom.padStart(2, '0')}` 
          : `${singleYear}-${singleMonth.padStart(2, '0')}`)}
    initialEndDate={viewMode === 'daily' || viewMode === 'weekly'
      ? (useDateRange ? dateTo : singleDate) 
      : (useDateRange 
          ? `${yearTo}-${monthTo.padStart(2, '0')}` 
          : `${singleYear}-${singleMonth.padStart(2, '0')}`)}
    initialViewMode={
      viewMode === 'daily' 
        ? 'day' 
        : viewMode === 'weekly'
          ? 'week'
          : 'month'
    }
    placeholder="Select Period"
  />
          </div>
          
          {/* Button to clear all saved settings */}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'flex-end',
            marginTop: '10px'
          }}>
            <button
              onClick={() => {
    clearSavedSettings();
    // Reset to default values
    setIsExplanationEnabled(false);
    setIsFilterOpen(true);
    setShowCountries(true);
    setShowCampaigns(true);
    setShowPChurn(false);
    setHideP1ToP4(false);
    setShowPredictedRevenue(false);
    setShowPCount(false);
    setShowWithTax(true);
    setHideAllPeriods(true);
    setShowEarlyPredicted(false);
    setShowPlatform(false);
    setDistributeUnknowns(false);
    setDistributeUnknowns(false);
    setSelectedCountries([]);
    setSelectedCampaigns([]);
    setSelectedPlatforms([]);  // ДОБАВИТЬ ЭТУ СТРОКУ
    setDateFrom(getTodayDate());
    setDateTo(getTodayDate());
    setSingleDate(getTodayDate());
    setUseDateRange(false);
    setViewMode('daily');
    setYearFrom(new Date().getFullYear().toString());
    setYearTo(new Date().getFullYear().toString());
    setMonthFrom('1');
    setMonthTo('12');
    setSingleYear(new Date().getFullYear().toString());
    setSingleMonth((new Date().getMonth() + 1).toString());
    setShowPeriodColumns([]);
  }}
              style={{
                padding: '6px 12px',
                border: '1px solid #dc3545',
                borderRadius: '4px',
                backgroundColor: '#fff',
                color: '#dc3545',
                cursor: 'pointer',
                fontSize: '12px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#dc3545';
                e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.color = '#dc3545';
              }}
            >
              Clear Saved Settings
            </button>
          </div>
          
          {/* Отображение активных фильтров */}
          <div style={{ 
            display: 'flex', 
            flexWrap: 'wrap',
            marginTop: '10px'
          }}>
        
          </div>
        </div>
      </div>
    );
  };
  
  // Хедер
  const Header: React.FC = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 30px',
    backgroundColor: 'white',
    borderRadius: '0 0 12px 12px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.06)',
    transition: 'all 0.3s ease'
  }}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <button 
        onClick={() => navigate('/')}
        style={{
          background: 'none',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          marginRight: '15px',
          color: '#495057',
          transition: 'transform 0.2s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <ArrowLeft size={24} />
      </button>
      <h1 style={{
        margin: 0,
        fontSize: '18px',
        fontWeight: 600,
        color: '#2c3e50'
      }}>
        {database} Dashboard
      </h1>
    </div>
    
    <div style={{ display: 'flex', gap: '10px' }}>
      {/* ДОБАВИТЬ КНОПКУ ПЕРЕКЛЮЧЕНИЯ РЕЖИМОВ */}
      <div style={{ 
        display: 'flex', 
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
        border: '1px solid #dee2e6',
        overflow: 'hidden'
      }}>
        <button 
          onClick={() => setViewType('table')}
          style={{
            padding: '8px 15px',
            border: 'none',
            backgroundColor: viewType === 'table' ? '#3498db' : 'transparent',
            color: viewType === 'table' ? 'white' : '#495057',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 500,
            transition: 'all 0.3s ease'
          }}
        >
          Table View
        </button>
        <button 
          onClick={() => setViewType('totals')}
          style={{
            padding: '8px 15px',
            border: 'none',
            backgroundColor: viewType === 'totals' ? '#3498db' : 'transparent',
            color: viewType === 'totals' ? 'white' : '#495057',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 500,
            transition: 'all 0.3s ease'
          }}
        >
          Totals View
        </button>
      </div>
      
      <button 
        onClick={() => setIsFilterOpen(!isFilterOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: isFilterOpen ? '#e9ecef' : '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '8px',
          padding: '8px 15px',
          color: '#495057',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <Filter size={16} />
        Filters
      </button>
      <button 
        onClick={() => setIsExplanationEnabled(!isExplanationEnabled)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: isExplanationEnabled ? '#2ecc71' : '#3498db',
          border: 'none',
          borderRadius: '8px',
          padding: '8px 15px',
          color: 'white',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        <span style={{ 
          display: 'inline-block',
          width: '16px',
          height: '16px',
          borderRadius: '50%',
          backgroundColor: isExplanationEnabled ? '#fff' : 'transparent',
          border: isExplanationEnabled ? 'none' : '2px solid #fff',
          marginRight: '5px'
        }}></span>
        Explanation
      </button>
    </div>
  </div>
);
  
  // Function to render the sort icon based on current sort state
  const renderSortIcon = (column: string): React.ReactNode => {
    if (sortColumn !== column) {
      return <ArrowUpDown size={16} className="sort-icon" />;
    }
    
    if (sortDirection === 'desc') {
      return <ArrowDown size={16} className="sort-icon" />;
    }
    
    if (sortDirection === 'asc') {
      return <ArrowUp size={16} className="sort-icon" />;
    }
    
    return <ArrowUpDown size={16} className="sort-icon" />;
  };
  
  // Рендер ячейки с поддержкой расшифровки
  const renderCell = (item: OrderData, key: string, value: any, label: string = '', periodNum?: number) => {
    return (
      <td 
        key={`${key}`} 
        style={{
          padding: '15px 10px',
          textAlign: 'right',
          color: '#495057',
          borderRight: '1px solid #e9ecef',
          borderBottom: '1px solid #e9ecef',
          cursor: isExplanationEnabled ? 'help' : 'default',
          ...(key.startsWith('predicted_') ? { backgroundColor: '#f0f4f8' } : {}),
          ...(key.startsWith('early_predicted_') || key === 'total_early_predicted_revenue' ? { backgroundColor: '#fff3e0' } : {})
        }}
        onMouseEnter={(e) => handleCellHover(e, item, key, label, periodNum)}
        onMouseLeave={handleCellLeave}
      >
        {value}
      </td>
    );
  };
  
  // Render P1-P12 values for a row
const renderPeriodValues = (item: OrderData) => {
  if (hideAllPeriods) return []; // если скрыты все периоды, возвращаем пустой массив
  
  const periodValues = [];
  const startPeriod = 1;
    
    for (let i = startPeriod; i <= 12; i++) {
      const periodKey = `revenue_p${i}` as keyof OrderData;
      const countKey = `revenue_p${i}_count` as keyof OrderData;
      const value = item[periodKey];
      
      // Применяем корректировку VAT к значению
      const adjustedValue = value !== null ? 
        getAdjustedRevenue(value as number, item.country) : null;
      
      periodValues.push(
        renderCell(
          item, 
          periodKey,
          adjustedValue !== null ? adjustedValue.toFixed(2) : '—',
          `Revenue Period ${i}`,
          i
        )
      );
      
      // Conditionally add churn column
      if (showPChurn) {
        periodValues.push(
          renderCell(
            item,
            `p${i}_churn`,
            calculateChurnRate(item, i),
            `Churn Rate for Period ${i}`
          )
        );
      }
      
      // Conditionally add count column
      if (showPCount) {
        const countValue = item[countKey];
        periodValues.push(
          renderCell(
            item,
            countKey,
            countValue !== null ? countValue : '—',
            `Count for Period ${i}`
          )
        );
      }
      
      // Conditionally add predicted revenue column
      if (showPredictedRevenue) {
        const predictedPeriodKey = `predicted_revenue_p${i}` as keyof OrderData;
        const predictedValue = item[predictedPeriodKey];
        
        // Применяем корректировку VAT к прогнозируемому значению
        const adjustedPredictedValue = predictedValue !== null && predictedValue !== undefined ? 
          getAdjustedRevenue(predictedValue as number, item.country) : null;
        
        periodValues.push(
          renderCell(
            item,
            predictedPeriodKey,
            adjustedPredictedValue !== null ? adjustedPredictedValue.toFixed(2) : '—',
            `Predicted Revenue Period ${i}`,
            i
          )
        );
      }
    }
    return periodValues;
  };
  
  // Create a sortable header cell component
  const SortableHeaderCell: React.FC<{
    column: string;
    title: string;
    vatAdjusted?: boolean;
    earlyPredicted?: boolean;
    style?: React.CSSProperties;
  }> = ({ column, title, vatAdjusted = false, earlyPredicted = false, style = {} }) => (
    <th 
      onClick={() => toggleSort(column)}
      style={{
        padding: '15px 15px',
        textAlign: 'right',
        fontWeight: 600,
        color: '#6c757d',
        fontSize: '13px',
        textTransform: 'uppercase',
        borderRight: '1px solid #e9ecef',
        borderBottom: '2px solid #dee2e6',
        cursor: 'pointer',
        position: 'sticky',
        top: 0,
        backgroundColor: sortColumn === column ? '#e9f7fe' : (earlyPredicted ? '#fff3e0' : '#f8f9fa'),
        transition: 'background-color 0.2s ease',
        ...style
      }}
    >
      <div style={{ 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: '5px'
      }}>
        {title}
        {renderSortIcon(column)}
      </div>
      {vatAdjusted && showWithTax && (
        <span style={{ 
          fontSize: '10px', 
          display: 'block', 
          fontWeight: 'normal',
          color: '#2c3e50',
          marginTop: '2px' 
        }}>
          After VAT
        </span>
      )}
      {earlyPredicted && (
        <span style={{ 
          fontSize: '10px', 
          display: 'block', 
          fontWeight: 'normal',
          color: '#ff6b35',
          marginTop: '2px' 
        }}>
          Early Predicted
        </span>
      )}
    </th>
  );
  

  // ==================== КОМПОНЕНТ "ПУЗЫРЬКА" (FilterChip) ====================
const FilterChip: React.FC<{
  label: string;
  onRemove: (label: string) => void;
}> = ({ label, onRemove }) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#e9ecef',
    borderRadius: '16px',
    padding: '4px 10px',
    margin: '4px',
    fontSize: '13px',
    lineHeight: 1.2,
    color: '#495057',
    transition: 'all 0.2s ease',
  }}>
    <span style={{ marginRight: '8px' }}>{label}</span>
    <button
      onClick={() => onRemove(label)}
      style={{
        background: '#adb5bd',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px',
        borderRadius: '50%',
        width: '16px',
        height: '16px',
        lineHeight: 1,
      }}
    >
      <X size={12} />
    </button>
  </div>
);

  // Helper function to sort data
  // Исправленная функция сортировки
const sortData = (data: { [date: string]: { [country: string]: OrderData[] } }): { [date: string]: { [country: string]: OrderData[] } } => {
  if (!sortColumn || !sortDirection) return data;

  // Create a new sorted object
  const sortedData: { [date: string]: { [country: string]: OrderData[] } } = {};
  
  // Get all the dates and sort them based on the selected column
  const dates = Object.keys(data);
  
  if (sortColumn && sortDirection) {
    dates.sort((dateA, dateB) => {
      // ИСПРАВЛЕНИЕ: Убираем flatMap, используем только reduce
      const valueA = Object.values(data[dateA]).reduce((totalSum, items) => {
        const itemsSum = items.reduce((itemSum, item) => {
          const itemValue = getColumnValue(item, sortColumn);
          return itemSum + (isNaN(itemValue) ? 0 : itemValue);
        }, 0);
        return totalSum + itemsSum;
      }, 0);
      
      const valueB = Object.values(data[dateB]).reduce((totalSum, items) => {
        const itemsSum = items.reduce((itemSum, item) => {
          const itemValue = getColumnValue(item, sortColumn);
          return itemSum + (isNaN(itemValue) ? 0 : itemValue);
        }, 0);
        return totalSum + itemsSum;
      }, 0);
      
      // Sort based on direction
      return sortDirection === 'desc' ? valueB - valueA : valueA - valueB;
    });
  }
  
  // Rebuild the object with sorted dates
  dates.forEach(date => {
    sortedData[date] = {};
    
    // Get all countries for this date and sort them
    const countries = Object.keys(data[date]);
    
    if (sortColumn && sortDirection) {
      countries.sort((countryA, countryB) => {
        // Calculate the total value for countryA
        const valueA = data[date][countryA].reduce((sum, item) => 
          sum + getColumnValue(item, sortColumn), 0
        );
        
        // Calculate the total value for countryB
        const valueB = data[date][countryB].reduce((sum, item) =>
          sum + getColumnValue(item, sortColumn), 0
        );
        
        // Sort based on direction
        return sortDirection === 'desc' ? valueB - valueA : valueA - valueB;
      });
    }
    
    // Rebuild country data with sorted countries
    countries.forEach(country => {
      const campaignItems = [...data[date][country]];
      
      // Sort campaigns within each country
      if (sortColumn && sortDirection) {
        campaignItems.sort((itemA, itemB) => {
          const valueA = getColumnValue(itemA, sortColumn);
          const valueB = getColumnValue(itemB, sortColumn);
          
          return sortDirection === 'desc' ? valueB - valueA : valueA - valueB;
        });
      }
      
      sortedData[date][country] = campaignItems;
    });
  });
  
  return sortedData;
};
  
  // Apply sorting to the data
  const sortedOrdersData = sortData(ordersData);
  
  // =================================================================
  // РАСЧЕТ ИТОГОВОЙ СТРОКИ (Total) ДЛЯ TABLE VIEW - ИСПРАВЛЕННАЯ ВЕРСИЯ
  // =================================================================
  // в AndroidDashboardPage.tsx

  // =================================================================
  // РАСЧЕТ ИТОГОВОЙ СТРОКИ (Total) ДЛЯ TABLE VIEW - ИСПРАВЛЕННАЯ ВЕРСИЯ
  // =================================================================
  const grandTotal = (() => {
    // Собираем все элементы данных, которые сейчас отображаются
    const allItems = Object.values(sortedOrdersData).flatMap(countries => 
      Object.values(countries).flat()
    );

    if (allItems.length === 0) return null;

    // Создаем пустой объект для суммирования
    const total: OrderData = {
      date_activation: 'Total',
      country: 'All',
      campaign: 'Total',
      arppu: 0, ltv: 0, predicted_ltv: 0, cpa_cost_per_action: 0, cpu_cost_per_user: 0, roi: 0, predicted_roi: 0,
      revenue_activation_count: 0, revenue_activation_purchase_count: 0, revenue_activation_purchase: 0, revenue_activation: 0,
      costs: 0, count_unique_payers: 0, count_unique_payers_activation: 0,
      revenue_p1: 0, revenue_p1_count: 0, revenue_p2: 0, revenue_p2_count: 0,
      revenue_p3: 0, revenue_p3_count: 0, revenue_p4: 0, revenue_p4_count: 0,
      revenue_p5: 0, revenue_p5_count: 0, revenue_p6: 0, revenue_p6_count: 0,
      revenue_p7: 0, revenue_p7_count: 0, revenue_p8: 0, revenue_p8_count: 0,
      revenue_p9: 0, revenue_p9_count: 0, revenue_p10: 0, revenue_p10_count: 0,
      revenue_p11: 0, revenue_p11_count: 0, revenue_p12: 0, revenue_p12_count: 0,
      total_revenue: 0, total_predicted_revenue: 0,
    };

    // Суммируем все "сырые" числовые поля
    allItems.forEach(item => {
      total.costs = (total.costs || 0) + (item.costs || 0);
      total.revenue_activation_count = (total.revenue_activation_count || 0) + (item.revenue_activation_count || 0);
      total.revenue_activation_purchase_count = (total.revenue_activation_purchase_count || 0) + (item.revenue_activation_purchase_count || 0);
      total.count_unique_payers = (total.count_unique_payers || 0) + (item.count_unique_payers || 0);
      total.count_unique_payers_activation = (total.count_unique_payers_activation || 0) + (item.count_unique_payers_activation || 0);
      
      // Суммируем доходы с учетом VAT
      total.revenue_activation = (total.revenue_activation || 0) + getAdjustedRevenue(item.revenue_activation || 0, item.country);
      
      for (let i = 1; i <= 12; i++) {
        const revenueKey = `revenue_p${i}` as keyof OrderData;
        const countKey = `revenue_p${i}_count` as keyof OrderData;
        const predictedKey = `predicted_revenue_p${i}` as keyof OrderData;
        const earlyPredictedKey = `early_predicted_revenue_p${i}` as keyof OrderData;
        
        (total[revenueKey] as number) += getAdjustedRevenue(item[revenueKey] as number || 0, item.country);
        (total[countKey] as number) += item[countKey] as number || 0;
        (total[predictedKey] as number) = ((total[predictedKey] as number) || 0) + getAdjustedRevenue(item[predictedKey] as number || 0, item.country);

        // Суммируем early predicted, обогащая каждый элемент
        const enrichedItem = enrichOrderDataWithEarlyPredicted(item, historicalCoefficients);
        (total[earlyPredictedKey] as number) = ((total[earlyPredictedKey] as number) || 0) + getAdjustedRevenue(enrichedItem[earlyPredictedKey] as number || 0, item.country);
      }
    });

    // Пересчитываем производные метрики на основе сумм
    // *** КЛЮЧЕВОЕ ИЗМЕНЕНИЕ ЗДЕСЬ ***
    const totalRevenue = allItems.reduce((sum, item) => sum + calculateTotalRevenue(item), 0);
    const totalPredictedRevenue = allItems.reduce((sum, item) => sum + calculatePredictedRevenue2(item), 0);
    const totalEarlyPredictedRevenue = allItems.reduce((sum, item) => sum + calculateEarlyPredictedRevenue(item), 0);
    
    const totalCosts = total.costs || 0;
    const totalUniquePayers = total.count_unique_payers || 0;
    const totalActivationPayers = total.count_unique_payers_activation || 0;
    const totalPurchases = total.revenue_activation_purchase_count || 0;


    total.total_revenue = totalRevenue; // Присваиваем рассчитанный total_revenue
    total.arppu = totalUniquePayers > 0 ? totalRevenue / totalUniquePayers : 0;
    total.ltv = totalActivationPayers > 0 ? totalRevenue / totalActivationPayers : 0;
    total.roi = totalCosts > 0 ? ((totalRevenue - totalCosts) / totalCosts) * 100 : 0;
    total.cpa_cost_per_action = totalPurchases > 0 ? totalCosts / totalPurchases : 0;
    total.cpu_cost_per_user = totalUniquePayers > 0 ? totalCosts / totalUniquePayers : 0;
    
    total.predicted_ltv = totalActivationPayers > 0 ? totalPredictedRevenue / totalActivationPayers : 0;
    total.predicted_roi = totalCosts > 0 ? ((totalPredictedRevenue - totalCosts) / totalCosts) * 100 : 0;
    (total.total_predicted_revenue as number) = totalPredictedRevenue;

    // Пересчитываем Early Predicted метрики для итоговой строки
    (total as any).early_predicted_ltv = totalActivationPayers > 0 ? totalEarlyPredictedRevenue / totalActivationPayers : 0;
    (total as any).early_predicted_roi = totalCosts > 0 ? ((totalEarlyPredictedRevenue - totalCosts) / totalCosts) * 100 : 0;
    (total as any).total_early_predicted_revenue = totalEarlyPredictedRevenue;

    return total;
  })();
  
  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh',
      backgroundColor: '#f4f6f9'
    }}>

      

    {/* ВСТАВИТЬ СЮДА - в самом начале, после открытия div */}
    {showInitialLoader && (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px'
        }}>
          <Loader2 
            size={64} 
            style={{ 
              animation: 'spin 1s linear infinite',
              color: '#3498db'
            }} 
          />

        </div>
      </div>
    )}

      {/* Хедер */}
      <Header />

  

      {/* Фильтры */}
    {/* Фильтры */}
      {isFilterOpen && <Filters />}




<CountryModal 
  isOpen={isCountryModalOpen}
  onClose={() => setIsCountryModalOpen(false)}
  allCountries={countries}
  allData={ordersData}
  initialSelection={selectedCountries}
  selectedCampaigns={selectedCampaigns}
  selectedPlatforms={selectedPlatforms}
  onApply={(newSelection) => {
    setSelectedCountries(newSelection);
    setIsCountryModalOpen(false);
  }}
/>

<CampaignModal 
  isOpen={isCampaignModalOpen}
  onClose={() => setIsCampaignModalOpen(false)}
  allCampaigns={campaigns}
  allData={unfilteredOrdersData} // Передаем нефильтрованные данные
  initialSelection={selectedCampaigns}
  selectedCountries={selectedCountries}
  selectedPlatforms={selectedPlatforms}
  onApply={(newSelection) => {
    setSelectedCampaigns(newSelection);
    setIsCampaignModalOpen(false);
  }}
/>

<PlatformModal
  isOpen={isPlatformModalOpen}
  onClose={() => setIsPlatformModalOpen(false)}
  allPlatforms={platforms}
  allData={ordersData}
  initialSelection={selectedPlatforms}
  selectedCountries={selectedCountries}
  selectedCampaigns={selectedCampaigns}
  onApply={(newSelection) => {
    setSelectedPlatforms(newSelection);
    setIsPlatformModalOpen(false);
  }}
/>

      {/* УСЛОВНЫЙ РЕНДЕРИНГ - показываем либо TotalsComponent, либо основную таблицу */}
      {viewType === 'totals' ? (

<>
{(useDateRange && (
            viewMode === 'daily' 
              ? (new Date(dateTo).getTime() - new Date(dateFrom).getTime()) / (1000 * 3600 * 24) > 0
              : viewMode === 'weekly'
                ? true  // Всегда показывать для weekly
                : (yearTo !== yearFrom || monthTo !== monthFrom)
          )) && (
            <CostsGraphComponent
              database={database}
              dateFrom={viewMode === 'daily' || viewMode === 'weekly' ? dateFrom : `${yearFrom}-${monthFrom.padStart(2, '0')}-01`}
              dateTo={viewMode === 'daily' || viewMode === 'weekly' ? dateTo : `${yearTo}-${monthTo.padStart(2, '0')}-${new Date(parseInt(yearTo), parseInt(monthTo), 0).getDate()}`}
              selectedCountries={selectedCountries}
              selectedCampaigns={selectedCampaigns}
              selectedPlatforms={selectedPlatforms}
              viewMode={viewMode}
              showWithTax={showWithTax}
              vatRates={vatRates}
            />
          )}



        <div>
          <TotalsComponent
  database={database}
  dateFrom={viewMode === 'daily' || viewMode === 'weekly' ? dateFrom : `${yearFrom}-${monthFrom.padStart(2, '0')}-01`}
  dateTo={viewMode === 'daily' || viewMode === 'weekly' ? dateTo : `${yearTo}-${monthTo.padStart(2, '0')}-${new Date(parseInt(yearTo), parseInt(monthTo), 0).getDate()}`}
  selectedCountries={selectedCountries}
  selectedCampaigns={selectedCampaigns}
  selectedPlatforms={selectedPlatforms}
  showCountries={showCountries}
  showCampaigns={showCampaigns}
  showWithTax={showWithTax}
  viewMode={viewMode === 'weekly' ? 'daily' : viewMode}
  hideAllPeriods={hideAllPeriods}
  showEarlyPredicted={showEarlyPredicted}
  vatRates={vatRates}
  distributeUnknowns={distributeUnknowns}
  distributeDirect={distributeDirect}
  onSelectCampaign={handleSelectCampaign}
/>
        </div>
   </>   ) : (
        // Показываем основной интерфейс с графиками и таблицей
        <>
{(useDateRange && (
            viewMode === 'daily'
              ? (new Date(dateTo).getTime() - new Date(dateFrom).getTime()) / (1000 * 3600 * 24) > 0
              : viewMode === 'weekly'
                ? true  // Всегда показывать для weekly
                : (yearTo !== yearFrom || monthTo !== monthFrom)
          )) && (
            <CostsGraphComponent
              database={database}
              dateFrom={viewMode === 'daily' || viewMode === 'weekly' ? dateFrom : `${yearFrom}-${monthFrom.padStart(2, '0')}-01`}
              dateTo={viewMode === 'daily' || viewMode === 'weekly' ? dateTo : `${yearTo}-${monthTo.padStart(2, '0')}-${new Date(parseInt(yearTo), parseInt(monthTo), 0).getDate()}`}
              selectedCountries={selectedCountries}
              selectedCampaigns={selectedCampaigns}
              selectedPlatforms={selectedPlatforms}
              viewMode={viewMode}
              showWithTax={showWithTax}
              vatRates={vatRates}
            />
          )}

               <div>
          <DaysComponents
  database={database}
  dateFrom={viewMode === 'daily' || viewMode === 'weekly' ? dateFrom : `${yearFrom}-${monthFrom.padStart(2, '0')}-01`}
  dateTo={viewMode === 'daily' || viewMode === 'weekly' ? dateTo : `${yearTo}-${monthTo.padStart(2, '0')}-${new Date(parseInt(yearTo), parseInt(monthTo), 0).getDate()}`}
  selectedCountries={selectedCountries}
  selectedCampaigns={selectedCampaigns}
  selectedPlatforms={selectedPlatforms}
  showCountries={showCountries}
  showCampaigns={showCampaigns}
  showWithTax={showWithTax}
  viewMode={viewMode === 'weekly' ? 'daily' : viewMode}
  hideAllPeriods={hideAllPeriods}
  showEarlyPredicted={showEarlyPredicted}
  vatRates={vatRates}
  distributeUnknowns={distributeUnknowns}
  distributeDirect={distributeDirect}
  onSelectCampaign={handleSelectCampaign}
/>
        </div>
   </>   )}
    </div>
  );
};

export default AndroidDashboardPage;